(function() {
    'use strict';

    angular
        .module('bestaaApp', [
            'ngStorage',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'chart.js'
        ])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('teoriprove', {
            parent: 'app',
            url: '/teoriprøve?type&subject',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/teoriprove/teoriprove.html',
                    controller: 'TeoriproveController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('teoriprove-result', {
            parent: 'app',
            url: '/teoriprøve/:sessionId/result',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/teoriprove/teoriprove-result.html',
                    controller: 'TeoriproveResultController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('TeoriproveResultController', TeoriproveResultController);

    TeoriproveResultController.$inject = ['$scope', '$http', '$state', '$stateParams', '$timeout'];

    function TeoriproveResultController ($scope, $http, $state, $stateParams, $timeout) {
        var vm = this;

        vm.hasTokenExpired = true;

        loadResult();

        function getToken() {
            return localStorage.getItem('sessionToken');
        }

        function loadResult() {
            var sessionId = $stateParams.sessionId;
            $http.get('api/' + getToken() + '/practice/' + sessionId + '/result')
                .then(function(result) {
                    vm.hasTokenExpired = result.data.hasTokenExpired;
                    $scope.result = result.data;
                }, function () {
                    alert("En feil oppstod.");
                });
        }

        $scope.showStartTemaproveExerciseModal = function (subject) {
            $scope.startTemaproveExerciseData = {};
            $scope.startTemaproveExerciseData.subject = subject;
            $('#startTemaproveExercise').modal('show');
        };

        $scope.startTemaproveExercise = function () {
            $('#startTemaproveExercise').modal('hide');

            // Wait a little bit to make the modal window close properly first
            $timeout(function() {
                $state.go('teoriprove', {
                    "type": $scope.startTemaproveExerciseData.practiceType,
                    "subject": $scope.startTemaproveExerciseData.subject
                });
            }, 300);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('TeoriproveController', TeoriproveController);

    TeoriproveController.$inject = ['$scope', '$http', '$state', '$stateParams', '$window', '$location', '$anchorScroll', '$timeout'];

    function TeoriproveController ($scope, $http, $state, $stateParams, $window, $location, $anchorScroll, $timeout) {
        var vm = this;

        $scope.errorReport = {};

        $scope.practiceType = $stateParams.type;

        if ($stateParams.type === 'TEMAPROVE_10' || $stateParams.type === 'SKILTPROVE_10') {
            vm.numberOfExercises = 10;
        } else if ($stateParams.type === 'TEMAPROVE_20') {
            vm.numberOfExercises = 20;
        } else if ($stateParams.type === 'TEMAPROVE_30') {
            vm.numberOfExercises = 30;
        } else {
            vm.numberOfExercises = 45;
        }

        loadFirstExercise();

        function getToken() {
            return localStorage.getItem('sessionToken');
        }

        function loadFirstExercise() {
            var data = {
                type: $stateParams.type,
                subject: $stateParams.subject
            };
            $http.post('api/' + getToken() + '/practice/new', data).then(function(result) {
                if (result.data.id === null) {
                    alert("Du har dessverre ikke tilgang til å starte ny prøve. Ønsker du å starte ny prøve kan du " +
                        "kjøpe tilgang ved å trykke på 'Kjøp tilgang nå'.");
                    $state.go('session');
                } else {
                    $scope.exercise = result.data;
                }
            });
        };

        $scope.next = function() {
            $scope.showExplanation = false;
            $http.get('api/' + getToken() + '/practice/' + $stateParams.type + '/' + $scope.exercise.sortOrder + '/next').then(function(result) {
                $scope.exercise = result.data;
            });
        };

        $scope.answer = function(option) {
            var data = {
                exerciseId: $scope.exercise.id,
                optionId: option.id
            };
            $http.post('api/' + getToken() + '/practice/' + $stateParams.type + '/answer', data).then(function(result) {
                $scope.exercise.explanation = result.data.explanation;
                if (result.data.correct === true) {
                    option.color = '#5cb85c';
                } else {
                    option.color = '#d9534f';
                    angular.forEach($scope.exercise.options, function(value, key) {
                        if (value.id === result.data.correctId) {
                            value.color = '#5cb85c';
                        }
                    });
                }
                $scope.showExplanation = true;
                $scope.practiceSessionDone = result.data.practiceSessionDone;

                // Scroll to bottom of page.
                $scope.scrollToBottom();
            });
        };

        $scope.scrollToBottom = function() {
            // Call $anchorScroll with the ID of the anchor at the bottom
            $timeout(function() {
                $anchorScroll('bottomAnchor');
            });
        };

        $scope.showReportErrorModal = function(exercise) {
            $scope.errorReport.exercise = exercise;
            $scope.errorReport.errorType = '';
            $('#reportErrorModal').modal('show');
        };

        $scope.sendErrorReport = function() {
            $http({
                method: 'POST',
                url: '/api/error/report',
                data: {
                    exerciseId: $scope.errorReport.exercise.id,
                    errorType: $scope.errorReport.errorType,
                    errorMessage: $scope.errorReport.errorMessage
                }
            }).then(function(response) {
                $('#reportErrorModal').modal('hide');
            }, function(response) {
                $('#reportErrorModal').modal('hide');
                console.log('An error occurred when uploading project log');
                console.log(result);
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('session', {
            parent: 'app',
            url: '/session/:token',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/session/session.html',
                    controller: 'SessionController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('info-to-students', {
            parent: 'app',
            url: '/informasjon',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/session/info-to-students.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('SessionController', SessionController);

    SessionController.$inject = ['$scope', '$state', '$http', '$stateParams', '$timeout'];

    function SessionController ($scope, $state, $http, $stateParams, $timeout) {
        var vm = this;

        vm.hasValidSessionToken = false;
        vm.hasTokenExpired = false;
        vm.hasInProgressTeoriprove = false;
        vm.hasInProgressTemaprove = false;
        vm.practiceType = null;
        vm.subject = null;
        vm.register = register;
        vm.registerDetails = {};

        validateToken($stateParams.token);

        function register () {
            // Get token from local storage
            var token = localStorage.getItem('sessionToken');
            $http.post('api/updateToken/' + token, vm.registerDetails).then(function(result) {
                vm.isRegistered = true;
            });
        }

        function validateToken(token) {
            if (!token) {
                token = localStorage.getItem('sessionToken');
            }
            $http.get('/api/loginWithToken/' + token).then(function(result) {
                vm.hasTokenExpired = result.data.hasTokenExpired;
                vm.expiryDate = result.data.expiryDate;
                vm.numberOfDaysLeftUntilExpiry = result.data.numberOfDaysLeftUntilExpiry;
                vm.teoriproveSessions = result.data.teoriproveSessions;
                vm.temaproveSessions = result.data.temaproveSessions;
                vm.skiltproveSessions = result.data.skiltproveSessions;
                vm.hasInProgressTeoriprove = result.data.hasInProgressTeoriprove;
                vm.hasInProgressTemaprove = result.data.hasInProgressTemaprove;
                vm.hasInProgressSkiltprove = result.data.hasInProgressSkiltprove;
                vm.practiceType = result.data.practiceType;
                vm.subject = result.data.subject;
                vm.hasValidSessionToken = result.data.validToken;
                vm.isRegistered = result.data.registered;
                vm.registerDetails.email = result.data.sentToEmailAddress;

                // If session token is valid, store this to local storage.
                if (vm.hasValidSessionToken) {
                    localStorage.setItem('sessionToken', token);
                }
            });
        }

        $scope.showStartTemaproveExerciseModal = function () {
            if (!vm.hasInProgressTemaprove && vm.hasTokenExpired) {
                return false;
            }
            $scope.startTemaproveExerciseData = {};
            $('#startTemaproveExercise').modal('show');
        };

        $scope.startTemaproveExercise = function () {
            $('#startTemaproveExercise').modal('hide');

            // Wait a little bit to make the modal window close properly first
            $timeout(function() {
                $state.go('teoriprove', {
                        "type": $scope.startTemaproveExerciseData.practiceType,
                        "subject": $scope.startTemaproveExerciseData.subject
                    });
            }, 300);
        };

        $scope.showStartSkiltproveExerciseModal = function () {
            if (!vm.hasInProgressSkiltprove && vm.hasTokenExpired) {
                return false;
            }
            $scope.startSkiltproveExerciseData = {};
            $('#startSkiltproveExercise').modal('show');
        };

        $scope.startSkiltproveExercise = function () {
            $('#startSkiltproveExercise').modal('hide');

            // Wait a little bit to make the modal window close properly first
            $timeout(function() {
                $state.go('teoriprove', {
                    "type": 'SKILTPROVE_' + $scope.startSkiltproveExerciseData.numberOfExercises
                });
            }, 300);
        };

        // Check if link to start new Teoriprøve should be disabled or not.
        $scope.isTeoriproveLinkDisabled = function() {
            if (!vm.hasInProgressTeoriprove && vm.hasTokenExpired) {
                return false;
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" >{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                //$state.go('home');

                // an authenticated user can't access to login and register pages
                /*
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                 */

                // recover and clear previousState after external login redirect (e.g. oauth2)
                /*
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                 */

                /* TODO: Is this needed???
                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }

                 */
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).then(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = data.headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('practice', {
            parent: 'app',
            url: '/practice',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/practice/practice.html',
                    controller: 'PracticeController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('PracticeController', PracticeController);

    PracticeController.$inject = ['$scope', '$http', '$state'];

    function PracticeController ($scope, $http, $state) {
        var vm = this;

        $scope.showExplanation = false;

        loadData();

        function loadData() {
            $http.get('/api/exercises/random/1').then(function(result) {
                $scope.exercise = result.data[0];
            });
        }

        /*
        $scope.exercise = {
            subject: {
                subject: 'Fører og eiers ansvar'
            },
            text: 'Hva er riktig når tilhengeren ikke har bremser og ikke er lastet?',
            imageUrl: '/images/1.png',
            options: [
                {
                    id: 1,
                    no: 'A',
                    text: 'Tilhengere uten bremser kan ikke brukes i Norge.',
                    color: 'white',
                    correct: false // TODO: remove
                },
                {
                    id: 2,
                    no: 'B',
                    text: 'Bilføreren må ha førerkort klasse B kode 96 eller førerkort klasse BE.',
                    color: 'white',
                    correct: false // TODO: remove
                },
                {
                    id: 3,
                    no: 'C',
                    text: 'Når det trekkes tilhengere uten bremser er høyeste tillatte fart 60 km/t.',
                    color: 'white',
                    correct: false // TODO: remove
                },
                {
                    id: 4,
                    no: 'D',
                    text: 'Når det trekkes tilhenger er høyeste tillatte fart 80 km/t.',
                    color: 'white',
                    correct: true // TODO: remove
                }
            ],
            explanation: 'Trafikkreglene § 13. Særlige bestemmelser om kjørefarten: På vegstrekninger med særskilt fartsgrense høyere enn 80 km i timen må motorvogn med tillatt totalvekt over 3500 kg eller motorvogn med tilhenger ikke kjøres fortere enn 80 km i timen'
        }
        */

        $scope.answer = function(option) {
            if (option.correct === true) {
                option.color = '#5cb85c';
            } else {
                option.color = '#d9534f';
                // TOOD: Need to find correct answer from server
                var i;
                for (i = 0; i < $scope.exercise.options.length; i++) {
                    var exerciseOption = $scope.exercise.options[i];
                    if (exerciseOption.correct === true) {
                        exerciseOption.color = '#5cb85c';
                        break;
                    }
                }
            }
            $scope.showExplanation = true;
        };

        $scope.reload = function() {
            $state.reload();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Error page!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('salespitch', {
            parent: 'app',
            url: '/hvorfor-velge-bestå',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/salespitch.html'
                }
            }
        })
        .state('access', {
            parent: 'app',
            url: '/tilgang',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/access.html'
                }
            }
        })
        .state('preparation', {
            parent: 'app',
            url: '/forberedelser',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/preparation.html'
                }
            }
        })
        .state('individuals', {
            parent: 'app',
            url: '/privatpersoner',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/individuals.html'
                }
            }
        })
        .state('terms_and_conditions', {
            parent: 'app',
            url: '/salgsvilkår',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/terms_and_conditions.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$http', 'AlertService', '$location'];

    function HomeController ($scope, Principal, LoginService, $http, AlertService, $location) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;

        vm.selectedNumberOfDays = "20";

        // Variables for chart.
        vm.labels = [];
        vm.series = ['Antall prøver'];
        vm.data = [];
        vm.myColors = ['#00ADF9'];

        // Put origin in local storage - if provided.
        if ($location.search().origin) {
            localStorage.setItem('origin', $location.search().origin)
        }

        getAccount();

        function loadData() {
            $http.get('/api/tokens').then(function(result) {
                vm.tokens = result.data;
            });

            // Only load chart data for admin.
            if (vm.account != null && Principal.hasAuthority('ROLE_ADMIN')) {
                $scope.loadChartData();
            }
        }

        $scope.loadChartData = function() {
            $http.get('/api/statistics/numberOfSessionsPerDay/' + vm.selectedNumberOfDays)
                .then(function (result) {
                    vm.labels = result.data.labels;
                    vm.data = [result.data.numbers];
                });
        };

        $scope.buyWithVipps = function() {
            alert('hello!');
        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
            loadData(); // Force a reload on authentication.
        });

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;

                // Load data if we have an account (i.e., is authenticated).
                if (vm.account) {
                    loadData();
                }
            });
        }

        $scope.showConfirmPurchaseModal = function(numKeys, pricePerKey) {
            vm.purchase = {};
            vm.purchase.numKeys = numKeys;
            vm.purchase.pricePerKey = pricePerKey;
            $('#confirmPurchaseModal').modal('show');
        };

        $scope.showConfirmDistributionModal = function(token) {
            vm.distribute = {};
            vm.distribute.token = token.token;
            vm.distribute.email = token.sentToEmail;
            $('#sendKeyToStudentModal').modal('show');
        };

        $scope.showConfirmRenewalOfTokenModal = function(token) {
            // TODO: Check if there are any available tokens.
            vm.renewal = {};
            vm.renewal.token = token.token;
            vm.renewal.student = token.student;
            $('#confirmRenewalOfTokenModal').modal('show');
        };

        $scope.showPrivacyPolicyModal = function() {
            $('#privacyPolicyModal').modal('show');
        };

        $scope.executePurchase = function() {
            $http({
                method: 'POST',
                url: 'api/tokens/create/' + vm.purchase.numKeys
            }).then(function(response) {
                AlertService.success("Kjøp gjennomført.", null, 'bottom right');
                loadData();
            }, function(response) {
                AlertService.error("En feil oppstod. Sjekk loggen!", null, 'bottom right');
                console.log(response);
            });
            $('#confirmPurchaseModal').modal('hide');
        };

        $scope.executeDistribution = function() {
            $http({
                method: 'POST',
                url: 'api/distribute/' + vm.distribute.token,
                data: {
                    email: vm.distribute.email
                }
            }).then(function(response) {
                AlertService.success("E-post sendt til " + vm.distribute.email + ".", null, 'bottom right');
                loadData();
            }, function(response) {
                AlertService.error("En feil oppstod. Sjekk loggen!", null, 'bottom right');
                console.log(response);
            });
            $('#sendKeyToStudentModal').modal('hide');
        };

        $scope.executeRenewal = function() {
            $http({
                method: 'POST',
                url: 'api/renew/' + vm.renewal.token
            }).then(function(response) {
                AlertService.success("Nøkkelen er fornyet.", null, 'bottom right');
                loadData();
            }, function(response) {
                AlertService.error("En feil oppstod. Sjekk loggen!", null, 'bottom right');
                console.log(response);
            });
            $('#confirmRenewalOfTokenModal').modal('hide');
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('bestaaApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('bestaaApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('bestaaApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        vm.closeLoginModal = closeLoginModal;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function closeLoginModal () {
            $uibModalInstance.dismiss('cancel');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('bestaaApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('bestaaApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('bestaaApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('bestaaApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'bestå' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('bestaaApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(true);
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('bestaaApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;



        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Bestaa'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('user-management-new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management-edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tokens', {
            parent: 'app',
            url: '/admin/tokens',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/token/token.html',
                    controller: 'TokenController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('TokenController', TokenController);

    TokenController.$inject = ['$scope', '$http', '$state'];

    function TokenController ($scope, $http, $state) {
        var vm = this;

        loadData();

        function loadData() {
            $http.get('/api/all/tokens').then(function(result) {
                vm.allTokens = result.data;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('bestaaApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('ExerciseDetailController', ExerciseDetailController);

    ExerciseDetailController.$inject = ['$scope', '$http','Principal', 'LoginService', '$state', '$stateParams', '$location'];

    function ExerciseDetailController ($scope, $http, Principal, LoginService, $state, $stateParams, $location) {
        var vm = this;

        vm.exercise = {};

        vm.previewImage = false;
        vm.currentId = $stateParams.id;

        // Available exercise types.
        vm.types = [
            {
                value: 'REGULAR',
                name: 'Teori/tema'
            }, {
                value: 'ROAD_SIGN',
                name: 'Skiltprøve'
            }
        ];

        // All available license classes.
        vm.licenseClasses = [
            {
                value: 'ALL',
                name: 'Alle'
            }, {
                value: 'LICENSE_CLASS_A',
                name: 'Førerkort klasse A'
            }, {
                value: 'LICENSE_CLASS_B',
                name: 'Førerkort klasse B'
            }
        ];

        loadData();

        function loadData() {
            if ($stateParams.id !== 'new') {
                $http.get('/api/exercise/' + $stateParams.id).then(function(result) {
                    vm.exercise = result.data;
                });
            }

            $http.get('/api/subjects').then(function(result) {
                vm.subjects = result.data;
            });
        }

        vm.addOption = function() {
            if(!vm.exercise.options) {
                vm.exercise.options = [];
            }
            vm.exercise.options.push({text: '', description: '', correct: false});
        };

        vm.removeOption = function(option) {
            vm.exercise.options.splice(vm.exercise.options.indexOf(option), 1);
        };

        vm.removeImage = function() {
            if ($stateParams.id !== 'new') {
                $http.delete('/api/exercise/' + $stateParams.id + '/delete/image/').then(function() {
                    vm.exercise.imageUrl = null;
                });
            }
            angular.element("#file").val('');
            vm.previewImage = false;
        };

        vm.save = function() {
            $http.post('/api/exercise', vm.exercise).then(function(result) {
                if (document.getElementById('file').files[0] !== null) {
                    var formData = new FormData();
                    formData.append('file', document.getElementById('file').files[0]);
                    formData.append('id', result.data);
                    $http.post("/api/exercise/upload/image", formData, {
                        headers: {
                            'Content-Type': undefined
                        }
                    }).then(function() {});
                }
            });
        };

        vm.next = function() {
            var nextId = parseInt(vm.currentId) + 1;
            $location.url("admin/exercises/" + nextId);
        };

        vm.prev = function() {
            var prevId = parseInt(vm.currentId) - 1;
            $location.url("admin/exercises/" + prevId);
        };

        angular.element("#file").change(function(){
            vm.previewImage = true;
            $scope.$apply();
            // eslint-disable-next-line angular/controller-as-vm
            readURL(this);
            vm.save();
        });

        function readURL(input) {
            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = function (e) {
                    angular.element('#image').attr('src', e.target.result);
                };

                reader.readAsDataURL(input.files[0]);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('exercises', {
            parent: 'app',
            url: '/admin/exercises',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/exercise/exercise.html',
                    controller: 'ExerciseController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('exercises-detail', {
            parent: 'app',
            url: '/admin/exercises/:id',
            data: {
                roles: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/exercise/exercise-detail.html',
                    controller: 'ExerciseDetailController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('ExerciseController', ExerciseController);

    ExerciseController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$http'];

    function ExerciseController ($scope, Principal, LoginService, $state, $http) {
        var vm = this;

        $scope.sortType = 'id';
        $scope.sortReverse = false;
        $scope.searchTable = '';

        loadData();

        $scope.deleteExercise = function() {
            var exercise = $scope.deleteExerciseCandidate;
            $http.delete('/api/exercise/' + exercise.id).then(function(result) {
                loadData();
                $('#confirmDelete').modal('hide');
            });
        }

        function loadData() {
            $http.get('/api/exercise/all').then(function(result) {
                $scope.exercises = result.data;
            });
        }

        $scope.showConfirmDialog = function(exercise) {
          $scope.deleteExerciseCandidate = exercise;
          $('#confirmDelete').modal('show');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('error-report', {
            parent: 'app',
            url: '/admin/error-report',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/error-report/error-report.html',
                    controller: 'ErrorReportController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('ErrorReportController', ErrorReportController);

    ErrorReportController.$inject = ['$scope', '$http', '$state'];

    function ErrorReportController ($scope, $http, $state) {
        var vm = this;

        loadData();

        function loadData() {
            $http.get('/api/error/report').then(function(result) {
                vm.errorReport = result.data;
            });
        }

        $scope.showConfirmDialog = function(errorReport) {
            $scope.errorReportToDelete = errorReport;
            $('#confirmDelete').modal('show');
        };

        $scope.deleteErrorReport = function () {
            var errorReport = $scope.errorReportToDelete;
            $http.delete('/api/error/report/' + errorReport.id).then(function(result) {
                loadData();
                $('#confirmDelete').modal('hide');
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth'];

    function SettingsController (Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/registrering',
            data: {
                authorities: [],
                pageTitle: 'Registrering'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = [ '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey =  'en' ;
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Passord styrke:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('bestaaApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/access.html','<div ng-cloak><div><div><h1>Hvordan f\xE5 tilgang?</h1></div><div class="row lead"><div class="col-md-12"><img src="content/images/access-image.jpg" class="shadow" style="width: 100%"></div><p class="col-xs-12"><br></p><p class="col-xs-12">Som elev kan du kontakte din lokale trafikkskole, eller snakke med trafikkl\xE6reren din. Vi anbefaler deg \xE5 kj\xF8pe via trafikkskolen, da blir det rimeligere for deg. Har ikke din trafikkskole best\xE5.no \u2028b\xF8r du tipse de om det.</p><p class="col-xs-12">G\xE5 til <a href="/#!/privatpersoner">Privatpersoner</a> for mer informasjon.</p><p class="col-xs-12">Som trafikkskole kan du f\xE5 tilgang ved \xE5 registrere deg. Gjennom best\xE5.no kan du som l\xE6rer f\xF8lge opp dine elever. Se flere fordeler n\xE5r du er logget inn. Registrering av trafikkskolen er GRATIS.</p><p class="col-xs-12">G\xE5 til <a href="/#!/registrering">Trafikkskoler</a> for mer informasjon.</p></div><a href="/#!/" class="btn btn-default"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> Tilbake til startsiden</a><br><br></div></div>');
$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div ng-switch="vm.isAuthenticated()" class="col-md-12"><!-- Not authenticated --><div ng-switch-when="false" style="text-align: center"><img src="content/images/logo_besta_ny.png" class="home-logo-img"><br><div style="margin-top: 50px"><vipps-checkout-button id="checkout-button" variant="primary" branded="true" rounded="true" style="font-size: 1.75rem"></vipps-checkout-button><script>var url = \'/api/vipps/checkout\';\n                        if (localStorage.getItem(\'origin\')) {\n                            url += \'?origin=\' + encodeURIComponent(localStorage.getItem(\'origin\'));\n                        }\n                        document\n                            .getElementById("checkout-button")\n                            .addEventListener("click", function () {\n                                // Relay an initiate session request to Checkout API through the merchant\'s backend\n                                fetch(url, {\n                                    method: "POST",\n                                })\n                                    .then((response) => response.json())\n                                    .then((data) => {\n                                        console.log(data);\n\n                                        VippsCheckoutDirect({\n                                            checkoutFrontendUrl: data.checkoutFrontendUrl,\n                                            language: "no",\n                                            token: data.token,\n                                        });\n                                    })\n                                    .catch((error) => {\n                                        console.log(\'failed!\');\n                                        console.log(error);\n                                        // Handle at least these two types of errors here:\n                                        // 1. Fetch to create session endpoint failed\n                                        // 2. Checkout frontend SDK not loaded resulting in VippsCheckout not being defined\n                                    });\n                            });</script></div><a href="/#!/privatpersoner" class="btn btn-primary btn-lg" style="margin-top: 10px; width: 260px">Privatpersoner</a><br><a href="/#!/registrering" class="btn btn-primary btn-lg" style="margin-top: 10px; width: 260px">Trafikkskoler</a><br><a href="/#!/hvorfor-velge-best\xE5" class="btn btn-primary btn-lg" style="margin-top: 10px; width: 260px">Hvorfor velge best\xE5.no</a><br><a href="/#!/tilgang" class="btn btn-primary btn-lg" style="margin-top: 10px; width: 260px">Hvordan f\xE5 tilgang</a><br><a href="/#!/forberedelser" class="btn btn-primary btn-lg" style="margin-top: 10px; width: 260px">Forberedelser til pr\xF8ven</a><div style="margin-top: 3px"><a ng-click="showPrivacyPolicyModal()">Personvern</a> | <a href="/#!/salgsvilk\xE5r">Salgsvilk\xE5r</a></div></div><!-- Authenticated --><div ng-switch-when="true"><!-- For administrator --><div has-authority="ROLE_ADMIN"><h1>Statistikk</h1><!-- Get this populated at some point. --><div class="pull-left" ng-show="vm.selectedNumberOfDays != 99999">Antall nye pr\xF8ver siste {{vm.selectedNumberOfDays}} dager</div><div class="pull-left" ng-show="vm.selectedNumberOfDays == 99999">Antall nye pr\xF8ver siden start</div><div class="pull-right">Antall dager:<select name="singleSelect" id="singleSelect" ng-model="vm.selectedNumberOfDays" ng-change="loadChartData()"><option value="20">20</option><option value="50">50</option><option value="100">100</option><option value="99999">Siden start</option></select></div><!-- Chart options: https://www.chartjs.org/docs/latest/charts/line.html --><canvas id="bar" class="chart chart-line" chart-data="vm.data" chart-labels="vm.labels" chart-series="vm.series" chart-options="{ legend: { display: true, labels: { fontSize: 10 } }, scales: { yAxes: [{ ticks: { beginAtZero: true }}]} }"></canvas></div><!-- For regular users --><div has-authority="ROLE_USER"><h1>Informasjon til trafikkskolen</h1><p class="lead">Vi gir inntil 50% av utbytte tilbake til skolene!</p><p>Vi har laget et system der det er trafikkskolen som tilbyr oppgaver p\xE5 nett til sine elever. Det finnes mange ulike tilbydere p\xE5 teorioppgaver p\xE5 nett, men det er bare vi som tilbyr dette direkte fra trafikkskolen. Laget av trafikkl\xE6rere med mange \xE5rs erfaring i faget, b\xE5de som trafikkl\xE6rer og med \xE5 lage oppgaver. Du kan ogs\xE5 f\xF8lge alle dine elevers progresjon for enkelt \xE5 se hvor elevene sliter - og m\xE5lrettet hjelpe til der det trengs.</p><p class="lead"></p><p>Flere fordeler med best\xE5.no:</p><ul><li>Temapr\xF8ver - eleven kan ta pr\xF8ver fra et spesifikt tema.</li><li>Alltid oppdaterte oppgaver.</li><li>Oppdatert etter nyeste l\xE6replaner.</li><li>Alle oppgavene gir forklaring til riktig svar.</li><li>Eleven/l\xE6rer kan rapportere feil (teknisk/skrivefeil/faktafeil, under hver oppgave).</li><li>m.m.</li></ul><div class="row" style="text-align: center"><div class="col-md-4"><div class="alert alert-success" role="alert"><div style="font-size: 20px; font-weight: bold">Antall koder: 50</div><small>50 lisenser \xE0 100 kr pr. stk.</small><p style="margin-top: 15px">Pris kr. 5.000,-</p><p>Utsalgspris til elev: 150,-</p><p style="font-size: 18px">Din fortjeneste: 2.500,-</p><br><button class="btn btn-sm btn-primary" ng-click="showConfirmPurchaseModal(50, 100)">Kj\xF8p 50 koder</button></div></div><div class="col-md-4"><div class="alert alert-success" role="alert"><div style="font-size: 20px; font-weight: bold">Antall koder: 100</div><small>100 lisenser \xE0 90 kr pr. stk.</small><p style="margin-top: 15px">Pris kr. 9.000,-</p><p>Utsalgspris til elev: 150,-</p><p style="font-size: 18px">Din fortjeneste: 6.000,-</p><br><button class="btn btn-sm btn-primary" ng-click="showConfirmPurchaseModal(100, 90)">Kj\xF8p 100 koder</button></div></div><div class="col-md-4"><div class="alert alert-success" role="alert"><div style="font-size: 20px; font-weight: bold">Antall koder: 500</div><small>500 lisenser \xE0 75 kr pr. stk.</small><p style="margin-top: 15px">Pris kr. 37.500,-</p><p>Utsalgspris til elev: 150,-</p><p style="font-size: 18px">Din fortjeneste: 37.500,-</p><br><button class="btn btn-sm btn-primary" ng-click="showConfirmPurchaseModal(500, 75)">Kj\xF8p 500 koder</button></div></div></div><div ng-show="vm.tokens.length > 0"><h3>Mine n\xF8kler</h3><input class="form-control" ng-model="filterString" placeholder="S\xF8k"><br><table class="table table-condensed table-hover"><th width="200px">Opprettet</th><th>Status</th><th>Sendt til</th><th>Elev</th><th>Telefon</th><th>Gyldig til</th><th style="width: 70px"></th><tr ng-repeat="sessionToken in vm.tokens | filter:filterString | orderBy:\'sortOrder\'"><td>{{sessionToken.createdTime}}</td><td>{{sessionToken.status}}</td><td>{{sessionToken.sentToEmail}}</td><td>{{sessionToken.student}}</td><td>{{sessionToken.phone}}</td><td>{{sessionToken.expiredDate}}</td><td><div class="pull-right"><a title="Forny n\xF8kkel" ng-click="showConfirmRenewalOfTokenModal(sessionToken)" ng-show="sessionToken.allowedToRenew"><span class="glyphicon glyphicon-repeat" aria-hidden="true"></span> </a><a title="Send p\xE5 e-post" ng-click="showConfirmDistributionModal(sessionToken)" ng-show="!sessionToken.allowedToRenew"><span class="glyphicon glyphicon-envelope" aria-hidden="true"></span> </a><a href="/#!/session/{{sessionToken.token}}" title="\xC5pne" target="_blank"><span class="glyphicon glyphicon-new-window" aria-hidden="true"></span></a></div></td></tr></table></div></div></div></div></div></div><div class="modal fade" id="confirmPurchaseModal"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title">Bekreft kj\xF8p</h4></div><div class="modal-body form-horizontal"><p>Vennligst bekreft at du \xF8nsker \xE5 kj\xF8pe <b>{{vm.purchase.numKeys}}</b> n\xF8kler til <b>{{vm.purchase.pricePerKey}},-</b> pr stk.</p><p>Du vil f\xE5 tilsendt en faktura for dette bel\xF8pet.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Avbryt</span></button> <button class="btn btn-success" ng-click="executePurchase()"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span>Bekreft kj\xF8p</span></button></div></div></div></div><div class="modal fade" id="sendKeyToStudentModal"><div class="modal-dialog"><div class="modal-content"><form name="sendKeyToStudentForm" ng-submit="executeDistribution()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title">Send n\xF8kkel p\xE5 e-post</h4></div><div class="modal-body form-horizontal"><p>Vennligst oppgi epost-adressen du \xF8nsker \xE5 sende denne n\xF8kkelen til:</p><p><input class="form-control" type="email" placeholder="Oppgi epost-adresse" ng-model="vm.distribute.email" required></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Avbryt</span></button> <button type="submit" class="btn btn-success" ng-disabled="sendKeyToStudentForm.$invalid"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span>Bekreft utsendelse</span></button></div></form></div></div></div><!-- Modal for showing a confirmation message to the user for confirming renewal of a given token. --><div class="modal fade" id="confirmRenewalOfTokenModal"><div class="modal-dialog"><div class="modal-content"><form name="confirmRenewalOfTokenForm" ng-submit="executeRenewal()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title">Bekreftelse</h4></div><div class="modal-body form-horizontal"><p>Vennligst bekreft at du \xF8nsker \xE5 fornye n\xF8kkelen til {{vm.renewal.student}}. Eleven vil da f\xE5 tilgang til best\xE5.no i 40 dager ekstra. Det vil sendes ut e-post til eleven om dette.</p><p>Merk at du m\xE5 ha minst 1 ubrukt n\xF8kkel tilgjengelig for \xE5 kunne fornye. Dersom du ikke har det kan du kj\xF8pe nye.</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Avbryt</span></button> <button type="submit" class="btn btn-success"><span class="glyphicon glyphicon-ok"></span>&nbsp;<span>Ja, forny n\xF8kkel</span></button></div></form></div></div></div><!-- Modal for showing the privacy policy (personvern/GDPR). --><div class="modal fade" id="privacyPolicyModal"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title">Personvern (GDPR)</h4></div><div class="modal-body"><p></p><h4>Hvilke opplysninger lagrer vi?</h4>Din epost-adresse, navn oppgitt under registrering og telefonnummer (om oppgitt). I tillegg lagrer vi resultat fra teoripr\xF8ver, temapr\xF8ver og skiltpr\xF8ver som du har tatt.<p></p><p></p><h4>Hva brukes mine opplysninger til?</h4>Kontaktopplysningene bruker vi for \xE5 ta kontakt med deg ved behov. Resultat fra pr\xF8ver brukes til anonymisert statistikk tilgjengelig for administrator.<p></p><p></p><h4>Hvordan sikrer best\xE5.no mine opplysninger?</h4>Informasjonen ligger lagret p\xE5 en sikker server hos AWS. I tillegg blir all kommunikasjon kryptert (HTTPS).<p></p><p></p><h4>Hvem har tilgang til mine opplysninger?</h4>Kun administrator av best\xE5.no har tilgang til dine opplysninger.<p></p><p></p><h4>Kan jeg f\xE5 innsyn i mine opplysninger?</h4>Absolutt! Send e-post til post@best\xE5.no for \xE5 f\xE5 tilsendt alle opplysninger vi har om deg.<p></p><p></p><h4>Kan dere slette mine opplysninger?</h4>S\xE5klart! Gi beskjed til post@best\xE5.no dersom du \xF8nsker at vi skal slette all informasjon om deg. Merk at dersom du har en aktiv n\xF8kkel vi din tilgang stenges.<p></p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Avbryt</span></button></div></div></div></div>');
$templateCache.put('app/home/individuals.html','<div ng-cloak><div><div><h1>Privatpersoner</h1></div><div class="row lead"><div class="col-xs-12"><img src="content/images/individuals-image.jpg" style="width: 100%" class="shadow"></div><p class="col-xs-12"><br></p><p class="col-xs-12">Det koster 250,- \xE5 kj\xF8pe tilgang til best\xE5.no i 40 dager. Du f\xE5r da f\xF8lgende:</p><span class="col-xs-12"><ul><li>40 dager fri bruk</li><li>Mulighet til \xE5 ta pr\xF8ver p\xE5 din mobiltelefon, eller nettbrett/PC</li><li>Du f\xE5r 45 oppgaver pr. pr\xF8ve og en tilbakemelding p\xE5 resultatet umiddelbart</li><li>Skiltpr\xF8ve</li><li>Temapr\xF8ve for \xE5 bli bedre p\xE5 et spesifikt tema</li><li>Du f\xE5r umiddelbar tilbakemelding p\xE5 svaret</li><li>Les hvorfor svaret var riktig/feil i forklaringen</li></ul></span><p class="col-xs-12">G\xE5 tilbake til startsiden og trykk p\xE5 "Kj\xF8p n\xE5 med Vipps" for \xE5 kj\xF8pe tilgang.</p></div><a href="/#!/" class="btn btn-default"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> Tilbake til startsiden</a><br><br></div></div>');
$templateCache.put('app/home/preparation.html','<div ng-cloak><div><div><h1>Forberedelse til pr\xF8ven</h1></div><div class="row lead"><div class="col-xs-12"><img src="content/images/preparation-image.jpg" style="width: 100%" class="shadow"></div><p class="col-xs-12"><br></p><p class="col-xs-12">Vi anbefaler at du leser og forbereder deg godt f\xF8r du g\xE5r inn og tar pr\xF8ven. Dersom en tradisjonell papirbok ikke er noe for deg kan vi anbefale den interaktive boken: <a href="https://itunes.apple.com/no/book/f%C3%B8rerkort-klasse-b/id878261369?l=nb&mt=11" target="_blank">F\xF8rerkort - Klasse B</a>. Her finner du mange filmer, oppgaver, animasjoner, og alt av tekst kan du f\xE5 opplest. Boken inneholder blant annet en film som viser deg hvordan du g\xE5r frem n\xE5r du skal ta teoripr\xF8ven.</p><h3 class="col-xs-12">Har du har str\xF8ket p\xE5 trafikkstasjonen?</h3><p class="col-xs-12">Se p\xE5 arket du fikk p\xE5 Trafikkstasjonen hvilke tema du hadde mest feil i. Velg temapr\xF8ve, og du kan velge oppgaver fra disse 9 temaene, samt antall oppgaver du vil jobbe med. N\xE5 har vi gjort det enkelt \xE5 \xF8ve p\xE5 tema der du hadde mange feil.</p><p class="col-xs-12">Se under for et eksempel p\xE5 en teoripr\xF8ve som ikke er best\xE5tt.</p><p class="col-xs-12" style="padding-top: 20px; padding-bottom: 20px"><img src="content/images/resultat_av_teoriprove.png" style="width: 75%" class="shadow"></p><p class="col-xs-12">Hva betyr egentlig 2 feil p\xE5 Fart og plassering? N\xE5r du er logget inn vil du f\xE5 eksempler og mer grundig forklaring p\xE5 hva de ulike tema inneholder.</p></div><a href="/#!/" class="btn btn-default"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> Tilbake til startsiden</a><br><br></div></div>');
$templateCache.put('app/home/salespitch.html','<div ng-cloak><div><div><h1>Hvorfor velge best\xE5.no?</h1></div><div class="row lead"><div class="col-md-12"><img src="content/images/salespitch-image.jpg" class="shadow" style="width: 100%"></div><p class="col-xs-12"><br></p><p class="col-xs-12">Vi har utviklet et system der trafikkskolene tilbyr oppgaver p\xE5 nett til sine elever.</p><p class="col-xs-12">Det finnes mange ulike tilbydere p\xE5 teorioppgaver p\xE5 nett, men det er bare vi som tilbyr oppgaver direkte fra trafikkskolen. P\xE5 den m\xE5ten sikrer vi tett oppf\xF8lging av deg som skal best\xE5 en teoripr\xF8ve. Det er bare vi som tilbyr temapr\xF8ver, dersom eleven har str\xF8ket p\xE5 trafikkstasjonen. Du kan lese mer om fordeler under <a href="/#!/forberedelser">forberedelse til pr\xF8ven</a>.</p><p class="col-xs-12">Andre fordeler med best\xE5.no:</p><span class="col-xs-12"><ul><li>best\xE5.no er en smartere m\xE5te \xE5 \xE5 l\xE6re seg teorien p\xE5</li><li>L\xF8pende oppdatering av oppgaver, og selvsagt etter nyeste l\xE6replaner</li><li>Alle oppgavene har utfyllende forklaringer</li><li>Vi har bred erfaring i faget, ikke bare som trafikkl\xE6rere men ogs\xE5 som utviklere av oppgaver</li><li>Vi har gjort eventuell rapportering enkelt for deg. Dette bidrar ogs\xE5 til at oppgavene holder h\xF8y kvalitet</li></ul></span></div><a href="/#!/" class="btn btn-default"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> Tilbake til startsiden</a><br><br></div></div>');
$templateCache.put('app/home/terms_and_conditions.html','<div ng-cloak><div><p class="row lead"></p><p class="col-xs-12"></p><h1>Salgsvilk\xE5r</h1><p></p><p class="col-xs-12"></p><h3>Innledning</h3>Dette kj\xF8pet er regulert av de nedenst\xE5ende standard salgsbetingelser for forbrukerkj\xF8p av varer over Internett. Forbrukerkj\xF8p over internett reguleres hovedsakelig av avtaleloven, forbrukerkj\xF8psloven, markedsf\xF8ringsloven, angrerettloven og ehandelsloven, og disse lovene gir forbrukeren ufravikelige rettigheter. Lovene er tilgjengelig p\xE5 www.lovdata.no. Vilk\xE5rene i denne avtalen skal ikke forst\xE5s som noen begrensning i de lovbestemte rettighetene, men oppstiller partenes viktigste rettigheter og plikter for handelen.<p></p><p class="col-xs-12"></p><h3>1. Avtalen</h3>Avtalen best\xE5r av disse salgsbetingelsene, opplysninger gitt i bestillingsl\xF8sningen og eventuelt s\xE6rskilt avtalte vilk\xE5r. Ved eventuell motstrid mellom opplysningene, g\xE5r det som s\xE6rskilt er avtalt mellom partene foran, s\xE5 fremt det ikke strider mot ufravikelig lovgivning.<br><br>Avtalen vil i tillegg bli utfylt av relevante lovbestemmelser som regulerer kj\xF8p av varer mellom n\xE6ringsdrivende og forbrukere.<p></p><p class="col-xs-12"></p><h3>2. Partene</h3>Selger er best\xE5.no (DevelopIT AS, org.no 913655486), og betegnes i det f\xF8lgende som selger/selgeren.<br><br>Kj\xF8per er den forbrukeren som foretar bestillingen, og betegnes i det f\xF8lgende som kj\xF8per/kj\xF8peren.<p></p><p class="col-xs-12"></p><h3>3. Pris</h3>Den oppgitte prisen for varen og tjenester er den totale prisen kj\xF8per skal betale. Denne prisen inkluderer alle avgifter og tilleggskostnader. Ytterligere kostnader som selger f\xF8r kj\xF8pet ikke har informert om, skal kj\xF8per ikke b\xE6re.<p></p><p class="col-xs-12"></p><h3>4. Avtaleinng\xE5else</h3>Avtalen er bindende for begge parter n\xE5r kj\xF8peren har sendt sin bestilling til selgeren.<br><br>Avtalen er likevel ikke bindende hvis det har forekommet skrive- eller tastefeil i tilbudet fra selgeren i bestillingsl\xF8sningen i nettbutikken eller i kj\xF8perens bestilling, og den annen part inns\xE5 eller burde ha innsett at det forel\xE5 en slik feil.<p></p><p class="col-xs-12"></p><h3>5. Betalingen</h3>Selgeren kan kreve betaling for varen fra det tidspunkt den blir sendt fra selgeren til kj\xF8peren. Betaling gj\xF8res via Vipps p\xE5 Nett.<p></p><p class="col-xs-12"></p><h3>6. Levering</h3>Levering er skjedd n\xE5r kj\xF8peren, eller hans representant, har mottatt e-post med innlogging til best\xE5.no. Hvis ikke leveringstidspunkt fremg\xE5r av bestillingsl\xF8sningen, skal selgeren levere varen til kj\xF8per uten un\xF8dig opphold og senest 30 dager etter bestillingen fra kunden. Varen skal leveres hos kj\xF8peren med mindre annet er s\xE6rskilt avtalt mellom partene.<p></p><p class="col-xs-12"></p><h3>7. Risikoen for varen</h3>Risikoen for varen g\xE5r over p\xE5 kj\xF8per n\xE5r han, eller hans representant, har f\xE5tt varene levert i tr\xE5d med punkt 6.<p></p><p class="col-xs-12"></p><h3>8. Angrerett</h3>Med mindre avtalen er unntatt fra angrerett, kan kj\xF8peren angre kj\xF8pet av varen i henhold til angrerettloven. Kj\xF8peren m\xE5 gi selger melding om bruk av angreretten innen 14 dager fra fristen begynner \xE5 l\xF8pe. I fristen inkluderes alle kalenderdager. Dersom fristen ender p\xE5 en l\xF8rdag, helligdag eller h\xF8ytidsdag forlenges fristen til n\xE6rmeste virkedag. Angrefristen anses overholdt dersom melding er sendt f\xF8r utl\xF8pet av fristen. Kj\xF8per har bevisbyrden for at angreretten er blitt gjort gjeldende, og meldingen b\xF8r derfor skje skriftlig (angrerettskjema, e-post eller brev). Angrefristen begynner \xE5 l\xF8pe: Ved kj\xF8p av enkeltst\xE5ende varer vil angrefristen l\xF8pe fra dagen etter varen(e) er mottatt. Selges et abonnement, eller inneb\xE6rer avtalen regelmessig levering av identiske varer, l\xF8per fristen fra dagen etter f\xF8rste forsendelse er mottatt. Best\xE5r kj\xF8pet av flere leveranser, vil angrefristen l\xF8pe fra dagen etter siste leveranse er mottatt. Angrefristen utvides til 12 m\xE5neder etter utl\xF8pet av den opprinnelige fristen dersom selger ikke f\xF8r avtaleinng\xE5elsen opplyser om at det foreligger angrerett og standardisert angreskjema. Tilsvarende gjelder ved manglende opplysning om vilk\xE5r, tidsfrister og fremgangsm\xE5te for \xE5 benytte angreretten. S\xF8rger den n\xE6ringsdrivende for \xE5 gi opplysningene i l\xF8pet av disse 12 m\xE5nedene, utl\xF8per angrefristen likevel 14 dager etter den dagen kj\xF8peren mottok opplysningene. Ved bruk av angreretten m\xE5 varen leveres tilbake til selgeren uten un\xF8dig opphold og senest 14 dager fra melding om bruk av angreretten er gitt. Kj\xF8per dekker de direkte kostnadene ved \xE5 returnere varen, med mindre annet er avtalt eller selger har unnlatt \xE5 opplyse om at kj\xF8per skal dekke returkostnadene. Selgeren kan ikke fastsette gebyr for kj\xF8perens bruk av angreretten. Kj\xF8per kan pr\xF8ve eller teste varen p\xE5 en forsvarlig m\xE5te for \xE5 fastsl\xE5 varens art, egenskaper og funksjon, uten at angreretten faller bort. Dersom pr\xF8ving eller test av varen g\xE5r utover hva som er forsvarlig og n\xF8dvendig, kan kj\xF8peren bli ansvarlig for eventuell redusert verdi p\xE5 varen. Selgeren er forpliktet til \xE5 tilbakebetale kj\xF8pesummen til kj\xF8peren uten un\xF8dig opphold, og senest 14 dager fra selgeren fikk melding om kj\xF8perens beslutning om \xE5 benytte angreretten. Selger har rett til \xE5 holde tilbake betalingen til han har mottatt varene fra kj\xF8peren, eller til kj\xF8per har lagt frem dokumentasjon for at varene er sendt tilbake.<p></p><p class="col-xs-12"></p><h3>9. Forsinkelse og manglende levering - kj\xF8pernes rettigheter og frist for \xE5 melde krav</h3>Dersom selgeren ikke leverer varen eller leverer den for sent i henhold til avtalen mellom partene, og dette ikke skyldes kj\xF8peren eller forhold p\xE5 kj\xF8perens side, kan kj\xF8peren i henhold til reglene i forbrukerkj\xF8pslovens kapittel 5 etter omstendighetene holde kj\xF8pesummen tilbake, kreve oppfyllelse, heve avtalen og/eller kreve erstatning fra selgeren. Ved krav om misligholdsbef\xF8yelser b\xF8r meldingen av bevishensyn v\xE6re skriftlig (for eksempel e-post).<h4>Oppfyllelse</h4>Kj\xF8per kan fastholde kj\xF8pet og kreve oppfyllelse fra selger. Kj\xF8per kan imidlertid ikke kreve oppfyllelse dersom det foreligger en hindring som selgeren ikke kan overvinne, eller dersom oppfyllelse vil medf\xF8re en s\xE5 stor ulempe eller kostnad for selger at det st\xE5r i vesentlig misforhold til kj\xF8perens interesse i at selgeren oppfyller. Skulle vanskene falle bort innen rimelig tid, kan kj\xF8per likevel kreve oppfyllelse. Kj\xF8peren taper sin rett til \xE5 kreve oppfyllelse om han eller hun venter urimelig lenge med \xE5 fremme kravet.<h4>Heving</h4>Dersom selgeren ikke leverer varen p\xE5 leveringstidspunktet, skal kj\xF8peren oppfordre selger til \xE5 levere innen en rimelig tilleggsfrist for oppfyllelse. Dersom selger ikke leverer varen innen tilleggsfristen, kan kj\xF8peren heve kj\xF8pet. Kj\xF8per kan imidlertid heve kj\xF8pet umiddelbart hvis selger nekter \xE5 levere varen. Tilsvarende gjelder dersom levering til avtalt tid var avgj\xF8rende for inng\xE5elsen av avtalen, eller dersom kj\xF8peren har underrettet selger om at leveringstidspunktet er avgj\xF8rende. Leveres tingen etter tilleggsfristen forbrukeren har satt eller etter leveringstidspunktet som var avgj\xF8rende for inng\xE5elsen av avtalen, m\xE5 krav om heving gj\xF8res gjeldende innen rimelig tid etter at kj\xF8peren fikk vite om leveringen.<h4>Erstatning</h4>Kj\xF8peren kan kreve erstatning for lidt tap som f\xF8lge av forsinkelsen. Dette gjelder imidlertid ikke dersom selgeren godtgj\xF8r at forsinkelsen skyldes hindring utenfor selgers kontroll som ikke med rimelighet kunne blitt tatt i betraktning p\xE5 avtaletiden, unng\xE5tt, eller overvunnet f\xF8lgene av.<p></p><p class="col-xs-12"></p><h3>10. Mangel ved varen - kj\xF8perens rettigheter og reklamasjonsfrist</h3>Hvis det foreligger en mangel ved varen m\xE5 kj\xF8per innen rimelig tid etter at den ble oppdaget eller burde ha blitt oppdaget, gi selger melding om at han eller hun vil p\xE5berope seg mangelen. Kj\xF8per har alltid reklamert tidsnok dersom det skjer innen 2 mnd. fra mangelen ble oppdaget eller burde blitt oppdaget. Reklamasjon kan skje senest to \xE5r etter at kj\xF8per overtok varen. Dersom varen eller deler av den er ment \xE5 vare vesentlig lenger enn to \xE5r, er reklamasjonsfristen fem \xE5r. Dersom varen har en mangel og dette ikke skyldes kj\xF8peren eller forhold p\xE5 kj\xF8perens side, kan kj\xF8peren i henhold til reglene i forbrukerkj\xF8psloven kapittel 6 etter omstendighetene holde kj\xF8pesummen tilbake, velge mellom retting og omlevering, kreve prisavslag, kreve avtalen hevet og/eller kreve erstatning fra selgeren. Reklamasjon til selgeren b\xF8r skje skriftlig.<h4>Retting eller omlevering</h4>Kj\xF8peren kan velge mellom \xE5 kreve mangelen rettet eller levering av tilsvarende ting. Selger kan likevel motsette seg kj\xF8perens krav dersom gjennomf\xF8ringen av kravet er umulig eller volder selgeren urimelige kostnader. Retting eller omlevering skal foretas innen rimelig tid. Selger har i utgangspunktet ikke rett til \xE5 foreta mer enn to avhjelpsfors\xF8k for samme mangel.<h4>Prisavslag</h4>Kj\xF8per kan kreve et passende prisavslag dersom varen ikke blir rettet eller omlevert. Dette inneb\xE6rer at forholdet mellom nedsatt og avtalt pris svarer til forholdet mellom tingens verdi i mangelfull og kontraktsmessig stand. Dersom s\xE6rlige grunner taler for det, kan prisavslaget i stedet settes lik mangelens betydning for kj\xF8peren.<h4>Heving</h4>Dersom varen ikke er rettet eller omlevert, kan kj\xF8peren ogs\xE5 heve kj\xF8pet n\xE5r mangelen ikke er uvesentlig.<p></p><p class="col-xs-12"></p><h3>11. Selgerens rettigheter ved kj\xF8perens mislighold</h3>Dersom kj\xF8peren ikke betaler eller oppfyller de \xF8vrige pliktene etter avtalen eller loven, og dette ikke skyldes selgeren eller forhold p\xE5 selgerens side, kan selgeren i henhold til reglene i forbrukerkj\xF8psloven kapittel 9 etter omstendighetene holde varen tilbake, kreve oppfyllelse av avtalen, kreve avtalen hevet samt kreve erstatning fra kj\xF8peren. Selgeren vil ogs\xE5 etter omstendighetene kunne kreve renter ved forsinket betaling, inkassogebyr og et rimelig gebyr ved uavhentede varer.<h4>Oppfyllelse</h4>Selger kan fastholde kj\xF8pet og kreve at kj\xF8peren betaler kj\xF8pesummen. Er varen ikke levert, taper selgeren sin rett dersom han venter urimelig lenge med \xE5 fremme kravet.<h4>Heving</h4>Selger kan heve avtalen dersom det foreligger vesentlig betalingsmislighold eller annet vesentlig mislighold fra kj\xF8perens side. Selger kan likevel ikke heve dersom hele kj\xF8pesummen er betalt. Fastsetter selger en rimelig tilleggsfrist for oppfyllelse og kj\xF8peren ikke betaler innen denne fristen, kan selger heve kj\xF8pet.<h4>Renter ved forsinket betaling/inkassogebyr</h4>Dersom kj\xF8peren ikke betaler kj\xF8pesummen i henhold til avtalen, kan selger kreve renter av kj\xF8pesummen etter forsinkelsesrenteloven. Ved manglende betaling kan kravet, etter forutg\xE5ende varsel, bli sendt til Kj\xF8per kan da bli holdt ansvarlig for gebyr etter inkassoloven.<h4>Gebyr ved uavhentede ikke-forskuddsbetalte varer</h4>Dersom kj\xF8peren unnlater \xE5 hente ubetalte varer, kan selger belaste kj\xF8per med et gebyr. Gebyret skal maksimalt dekke selgerens faktiske utlegg for \xE5 levere varen til kj\xF8peren. Et slikt gebyr kan ikke belastes kj\xF8pere under 18 \xE5r.<p></p><p class="col-xs-12"></p><h3>12. Garanti</h3>Garanti som gis av selgeren eller produsenten, gir kj\xF8peren rettigheter i tillegg til de kj\xF8peren allerede har etter ufravikelig lovgivning. En garanti inneb\xE6rer dermed ingen begrensninger i kj\xF8perens rett til reklamasjon og krav ved forsinkelse eller mangler etter punkt 9 og 10.<p></p><p class="col-xs-12"></p><h3>13. Personopplysninger</h3>Behandlingsansvarlig for innsamlede personopplysninger er selger. Med mindre kj\xF8peren samtykker til noe annet, kan selgeren, i tr\xE5d med personopplysningsloven, kun innhente og lagre de personopplysninger som er n\xF8dvendig for at selgeren skal kunne gjennomf\xF8re forpliktelsene etter avtalen. Kj\xF8perens personopplysninger vil kun bli utlevert til andre hvis det er n\xF8dvendig for at selger skal f\xE5 gjennomf\xF8rt avtalen med kj\xF8peren, eller i lovbestemte tilfelle.<p></p><p class="col-xs-12"></p><h3>14. Konfliktl\xF8sning</h3>Klager rettes til selger innen rimelig tid, jf. punkt 9 og 10. Partene skal fors\xF8ke \xE5 l\xF8se eventuelle tvister i minnelighet. Dersom dette ikke lykkes, kan kj\xF8peren ta kontakt med Forbrukerr\xE5det for mekling. Forbrukerr\xE5det er tilgjengelig p\xE5 telefon 23 400 500 eller www.forbrukerradet.no.<p></p><p></p><a href="/#!/" class="btn btn-default"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> Tilbake til startsiden</a><p></p></div></div>');
$templateCache.put('app/practice/practice.html','<div ng-cloak><div class="row" style="margin-bottom: 50px"><div class="col-md-12"><p style="font-size: 20px">{{exercise.subject.subject}}</p><img ng-src="{{exercise.imageUrl}}" width="100%"><p style="margin-top: 10px" class="lead">{{exercise.text}}</p></div><div class="list-group"><button ng-repeat="option in exercise.options" type="button" class="list-group-item" style="height: 60px; background-color: {{option.color}}" ng-click="answer(option)" ng-disabled="showExplanation"><div class="col-xs-2 col-sm-1">{{option.no}}</div><div class="col-xs-10 col-sm-11">{{option.text}}</div></button></div><div ng-show="showExplanation" class="col-md-12"><p><b>Forklaring</b></p><p>{{exercise.explanation}}</p></div><button class="btn btn-default btn-lg" ng-click="reload()">Neste oppgave</button></div></div>');
$templateCache.put('app/session/info-to-students.html','<div ng-cloak><div><div><h1>De 9 ulike temaene</h1><!-- Image. --> <img style="width: 100%; height: auto" class="shadow" src="content/images/info-image.jpg"><div class="text-left" style="margin-top: 20px"><h3>Har du har str\xF8ket p\xE5 trafikkstasjonen?</h3><p class="lead">Dersom du er s\xE5 uheldig \xE5 stryker p\xE5 teoripr\xF8ven vil du f\xE5 et ark der det st\xE5r f.eks. 5 feil p\xE5 fart og plassering og 4 feil p\xE5 skilt og oppmerking. Men hva betyr egentlig dette?</p><h3>Statens vegvesen deler alle oppgaver inn i 7 ulike tema</h3><small>Trykk p\xE5 de ulike emner for \xE5 se mer info</small><div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true"><div class="panel panel-default"><div class="panel-heading" role="tab" id="headingOne"><h4 class="panel-title"><a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne" onclick="return false;">Fart og plassering</a></h4></div><div id="collapseOne" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingOne"><div class="panel-body"><table class="table table-striped table-condensed"><thead><th>Ulike emner</th><th>Eks. p\xE5 oppgave:</th></thead><tbody><tr><td>Avstand til forankj\xF8rende</td><td>Reglene sier at avstand til forankj\xF8rende\u2026</td></tr><tr><td>Enveiskj\xF8ring</td><td>Hvilke felt vil du velge n\xE5r fu skal rett fram?</td></tr><tr><td>Hest i trafikken</td><td>Hva vil du gj\xF8re i denne situasjonen?</td></tr><tr><td>Bremselengde</td><td>Hva blir bremselengden om du \xF8ker farten fra 30km/t til 90 km/t?</td></tr><tr><td>Signal og tegn</td><td>Hva er forskjellen p\xE5 tegn og signal?</td></tr><tr><td>Kollektivfelt og flerbruksfelt</td><td>Hva forteller skiltet deg?</td></tr></tbody></table></div></div></div><div class="panel panel-default"><div class="panel-heading" role="tab" id="headingThree"><h4 class="panel-title"><a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree" onclick="return false;">F\xF8rer og andre trafikanter</a></h4></div><div id="collapseThree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree"><div class="panel-body"><table class="table table-striped table-condensed"><thead><th>Ulike emner</th><th>Eks. p\xE5 oppgave:</th></thead><tbody><tr><td>Sanser</td><td>Vi har sansemessige begrensninger. Hva er riktig?</td></tr><tr><td>Forhold mellom trafikanter</td><td>Eldre trafikanter kan ha problemer i trafikken fordi...</td></tr><tr><td>Milj\xF8hensyn</td><td>For \xE5 kj\xF8re mest mulig milj\xF8vennlig m\xE5 jeg...</td></tr></tbody></table></div></div></div><div class="panel panel-default"><div class="panel-heading" role="tab" id="headingTwo"><h4 class="panel-title"><a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo" onclick="return false;">F\xF8rer og eiers ansvar</a></h4></div><div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo"><div class="panel-body"><table class="table table-striped table-condensed"><thead><th>Ulike emner</th><th>Eks. p\xE5 oppgave:</th></thead><tbody><tr><td>Registrering av kj\xF8ret\xF8y</td><td>Ved registrering til ny eier m\xE5 f\xF8lgende dokument\u2026</td></tr><tr><td>Vognkort</td><td>Hva er riktig om vognkort?</td></tr><tr><td>Eierforhold</td><td>Hva er riktig om motorvogn som skifter eier?</td></tr><tr><td>F\xF8rerkortforhold</td><td>Hva er riktig om f\xF8rerkort klasse B?</td></tr><tr><td>Forsikring</td><td>Hva dekkes av motorvognens trafikkforsikring?</td></tr><tr><td>\xD8konomisk forhold</td><td>Kan ulovlig \xF8velseskj\xF8ring medf\xF8re \xF8konomisk ansvar?</td></tr><tr><td>Vilk\xE5r for \xE5 \xF8vingskj\xF8re</td><td>Hva sier bestemmelsene om \xF8vingskj\xF8ring med bil?</td></tr><tr><td>Straff ved overtredelse</td><td>Oppgaven handler om straffereaksjoner. Hva er riktig p\xE5stand?</td></tr><tr><td>Pliktmessig avhold</td><td>Gjelder reglene om pliktmessig avhold for f\xF8rer med kl. B f\xF8rerkort?</td></tr></tbody></table></div></div></div><div class="panel panel-default"><div class="panel-heading" role="tab" id="headingSeven"><h4 class="panel-title"><a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven" onclick="return false;">Kj\xF8ret\xF8yet</a></h4></div><div id="collapseSeven" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingSeven"><div class="panel-body"><table class="table table-striped table-condensed"><thead><th>Ulike emner</th><th>Eks. p\xE5 oppgave:</th></thead><tbody><tr><td>Forskriftsmessig stand</td><td>Hva sier forskriftene om at kj\xF8ret\xF8y skal v\xE6re i forsvarlig stand?</td></tr><tr><td>Forsvarlig stand</td><td>Hvem er ansvarlig for at bilen er i forsvarlig stand?</td></tr><tr><td>Bremser</td><td>Hvilket krav til bremser er riktig?</td></tr><tr><td>Hjul</td><td>Hvordan kan du oppdage at bilens forhjul er i ubalanse?</td></tr><tr><td>Dekk</td><td>Dekkenes m\xF8nsterdybde\u2026</td></tr><tr><td>Styring</td><td>Hvordan utf\xF8res kontrollere av servostyringen?</td></tr><tr><td>Lys</td><td>Hva er riktig om Xenon-lys?</td></tr><tr><td>Sikkerhetsutstyr</td><td>Med bilens aktive og passive sikkerhet menes:</td></tr><tr><td>Varselinnretninger</td><td>Hva betyr det at denne varsellampen lyser n\xE5r bilen st\xE5r i ro?</td></tr><tr><td>Tilhenger</td><td>Du skal kj\xF8re med tilhenger. Hva er riktig?</td></tr><tr><td>Lasting av bil og tilhenger</td><td>Hva m\xE5 du ta hensyn til n\xE5r du har tung last i hengeren?</td></tr></tbody></table></div></div></div><div class="panel panel-default"><div class="panel-heading" role="tab" id="headingFour"><h4 class="panel-title"><a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFour" aria-expanded="false" aria-controls="collapseFour" onclick="return false;">Lover og regler</a></h4></div><div id="collapseFour" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFour"><div class="panel-body"><table class="table table-striped table-condensed"><thead><th>Ulike emner</th><th>Eks. p\xE5 oppgave:</th></thead><tbody><tr><td>Trafikkregler</td><td>Er det tillat p\xE5 parker her?</td></tr><tr><td>Vegtrafikkloven \xA7 3</td><td>Hva er riktig om vegtrafikklovens \xA73</td></tr></tbody></table></div></div></div><div class="panel panel-default"><div class="panel-heading" role="tab" id="headingFive"><h4 class="panel-title"><a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseFive" aria-expanded="false" aria-controls="collapseFive" onclick="return false;">Skilt og Oppmerking</a></h4></div><div id="collapseFive" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingFive"><div class="panel-body"><table class="table table-striped table-condensed"><thead><th>Ulike emner</th><th>Eks. p\xE5 oppgave:</th></thead><tbody><tr><td>Skiltgrupper</td><td>Hvilke skiltgruppe til dette skiltet?</td></tr><tr><td>Oppmerking</td><td>Hva betyr gul sperrelinje?</td></tr></tbody></table></div></div></div><div class="panel panel-default"><div class="panel-heading" role="tab" id="headingNine"><h4 class="panel-title"><a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseNine" aria-expanded="false" aria-controls="collapseNine" onclick="return false;">Vikeplikt</a></h4></div><div id="collapseNine" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingNine"><div class="panel-body"><table class="table table-striped table-condensed"><thead><th>Ulike emner</th><th>Eks. p\xE5 oppgave:</th></thead><tbody><tr><td>\xA7 7 om vikeplikt</td><td>Trafikkreglenes \xA7 7 om vikeplikt sier at\u2026</td></tr><tr><td>Fri veg</td><td>Du skal gi fri vei for\u2026</td></tr><tr><td>Vike- og stoppskilt</td><td>Hva er forskjell p\xE5 vikeplikt og stoppeplikt?</td></tr><tr><td>Vikeplikt ved rygging</td><td>Trafikkreglene om rygging og vending sier at\u2026</td></tr><tr><td>Vikeplikt for buss</td><td>N\xE5r har du vikeplikt for buss ut fra holdeplass?</td></tr></tbody></table></div></div></div></div></div></div><a href="/#!/session/" class="btn btn-default"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> Tilbake til startsiden</a><br><br></div></div>');
$templateCache.put('app/session/session.html','<script>addToHomescreen({\n        skipFirstVisit: false,\n        maxDisplayCount: 3\n    });</script><div ng-cloak><div class="row"><div><div ng-show="!vm.isRegistered && vm.hasValidSessionToken" style="text-align: center"><p class="lead">Vennligst fyll inn informasjonen under for \xE5 fullf\xF8re registreringen</p><form class="col-sm-6 col-sm-offset-3" name="form"><input class="form-control input-lg" placeholder="Navn*" id="student" name="student" ng-model="vm.registerDetails.student" required><div ng-show="form.student.$dirty && form.student.$invalid"><p class="help-block" ng-show="form.student.$error.required">Du m\xE5 skrive inn et navn.</p></div><br><input type="email" class="form-control input-lg" placeholder="E-post" id="email" name="email" ng-model="vm.registerDetails.email"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.email">Epost-adressen er ikke gyldig.</p></div><br><input class="form-control input-lg" type="number" placeholder="Mobil" id="phone" name="phone" ng-model="vm.registerDetails.phone" ng-minlength="8" ng-maxlength="8"><div ng-show="form.phone.$dirty && form.phone.$invalid"><p class="help-block" ng-show="form.phone.$error.minlength">Ugyldig mobil-nummer.</p><p class="help-block" ng-show="form.phone.$error.maxlength">Ugyldig mobil-nummer.</p></div><br><button ng-click="vm.register()" ng-disabled="form.$invalid" class="btn btn-lg btn-default">Registrer</button></form></div><!-- Information about full access (only for non-mobile screens). --><div class="col-sm-12 hidden-xs" ng-show="vm.expiryDate && vm.numberOfDaysLeftUntilExpiry >= 0"><p class="lead pull-right">Tilgangen utg\xE5r {{vm.expiryDate}}, om {{vm.numberOfDaysLeftUntilExpiry}} dag(er)</p></div><!-- Information about limited access. --><div class="col-sm-12" ng-show="vm.hasValidSessionToken && vm.hasTokenExpired"><div class="alert alert-danger" role="alert"><span class="lead"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> Begrenset tilgang</span><br><div style="margin-top: 5px">Du vil fortsatt ha tilgang til tidligere pr\xF8ver og vil kunne avslutte p\xE5g\xE5ende pr\xF8ver, men vil ikke kunne starte en ny pr\xF8ve. Ta kontakt med trafikkskolen din dersom du \xF8nsker \xE5 forlenge tilgangen din til best\xE5.no. Du kan ogs\xE5 kj\xF8pe tilgang fra oss direkte dersom du \xF8nsker det. Kontoen din vil da l\xE5ses opp og du vil ha full tilgang til alle pr\xF8ver.</div><div style="margin-top: 8px" class="text-center"><vipps-checkout-button id="checkout-button" variant="orange" branded="true" style="font-size: 1.75rem"></vipps-checkout-button><script>document\n                                .getElementById("checkout-button")\n                                .addEventListener("click", function () {\n                                    // Relay an initiate session request to Checkout API through the merchant\'s backend\n                                    fetch("/api/vipps/checkout?sessionToken=" + localStorage.getItem(\'sessionToken\') , {\n                                        method: "POST",\n                                    })\n                                        .then((response) => response.json())\n                                        .then((data) => {\n                                            console.log(data);\n\n                                            VippsCheckoutDirect({\n                                                checkoutFrontendUrl: data.checkoutFrontendUrl,\n                                                language: "no",\n                                                token: data.token,\n                                            });\n                                        })\n                                        .catch((error) => {\n                                            console.log(\'failed!\');\n                                            console.log(error);\n                                            // Handle at least these two types of errors here:\n                                            // 1. Fetch to create session endpoint failed\n                                            // 2. Checkout frontend SDK not loaded resulting in VippsCheckout not being defined\n                                        });\n                                });</script></div></div></div><div ng-show="vm.hasValidSessionToken && vm.isRegistered" style="text-align: center"><div class="col-sm-12 hidden-xs"><img style="width: 100%; height: auto" class="shadow" src="content/images/volvo.jpg"></div><div class="col-sm-12 visible-xs"><img style="width: 200px" src="content/images/logo_besta_ny.png"></div><!-- Information about full access (only for mobile screens). --><div class="col-sm-12 visible-xs" ng-show="vm.expiryDate && vm.numberOfDaysLeftUntilExpiry >= 0"><p class="lead">Tilgangen utg\xE5r {{vm.expiryDate}}, om {{vm.numberOfDaysLeftUntilExpiry}} dag(er)</p></div><div class="col-sm-8 col-sm-offset-2" style="margin-top: 10px"><!-- Teoripr\xF8ve --> <a class="btn btn-success btn-lg" href="/#!/teoripr\xF8ve?type=TEORIPROVE" ng-click="vm.isTeoriproveLinkDisabled()" style="margin-top: 10px; width: 220px" ng-class="{disabled: !vm.hasInProgressTeoriprove && vm.hasTokenExpired}"><div ng-show="!vm.hasInProgressTeoriprove"><span class="glyphicon glyphicon-road" aria-hidden="true"></span> Start teoripr\xF8ve</div><div ng-show="vm.hasInProgressTeoriprove"><span class="glyphicon glyphicon-road" aria-hidden="true"></span> Fortsett teoripr\xF8ve</div></a><!-- Temapr\xF8ve --> <a class="btn btn-success btn-lg" ng-show="!vm.hasInProgressTemaprove" style="margin-top: 10px; width: 220px" ng-click="showStartTemaproveExerciseModal()" ng-class="{disabled: !vm.hasInProgressTemaprove && vm.hasTokenExpired}"><span class="glyphicon glyphicon-book" aria-hidden="true"></span> Start temapr\xF8ve </a><a class="btn btn-success btn-lg" style="margin-top: 10px" ng-show="vm.hasInProgressTemaprove" href="/#!/teoripr\xF8ve?type={{vm.practiceType}}&subject={{vm.subject}}"><span class="glyphicon glyphicon-book" aria-hidden="true"></span> Fortsett temapr\xF8ve </a><!-- Skiltpr\xF8ve --> <a class="btn btn-success btn-lg" ng-show="!vm.hasInProgressSkiltprove" style="margin-top: 10px; width: 220px" ng-click="showStartSkiltproveExerciseModal()" ng-class="{disabled: !vm.hasInProgressSkiltprove && vm.hasTokenExpired}"><span class="glyphicon glyphicon-warning-sign" aria-hidden="true"></span> Start skiltpr\xF8ve </a><a class="btn btn-success btn-lg" style="margin-top: 10px" ng-show="vm.hasInProgressSkiltprove" href="/#!/teoripr\xF8ve?type={{vm.practiceType}}"><span class="glyphicon glyphicon-warning-sign" aria-hidden="true"></span> Fortsett skiltpr\xF8ve</a></div><div class="col-sm-8 col-sm-offset-2 lead" style="margin-top: 10px"><a href="/#!/informasjon"><span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span> Les om de 7 ulike temaene</a></div></div><div ng-show="!vm.hasValidSessionToken" style="text-align: center"><p class="lead">Ingen gyldig kode funnet. Ta kontakt med trafikkskolen din for \xE5 f\xE5 en kode.</p></div><div class="col-xs-12" ng-show="vm.teoriproveSessions.length > 0"><h3>Teoripr\xF8ver <small>(siste 25 pr\xF8ver)</small></h3><div class="list-group"><a type="button" class="list-group-item" ng-repeat="session in vm.teoriproveSessions" href="/#!/teoripr\xF8ve/{{session.id}}/result"><div class="pull-right"><span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span></div><div><span class="label label-success" ng-show="session.passed">GODKJENT</span> <span class="label label-danger" ng-show="!session.passed">IKKE GODKJENT</span> &nbsp;&nbsp;{{session.text}}</div></a></div></div><div class="col-xs-12" ng-show="vm.temaproveSessions.length > 0"><h3>Temapr\xF8ver <small>(siste 25 pr\xF8ver)</small></h3><div class="list-group"><div class="list-group-item" ng-repeat="session in vm.temaproveSessions"><span class="label label-default">{{session.subject}}</span> &nbsp;&nbsp;{{session.text}}</div></div></div><!-- Skilpr\xF8ver. --><div class="col-xs-12" ng-show="vm.skiltproveSessions.length > 0"><h3>Skiltpr\xF8ver <small>(siste 25 pr\xF8ver)</small></h3><div class="list-group"><div class="list-group-item" ng-repeat="session in vm.skiltproveSessions">{{session.text}}</div></div></div></div></div></div><div class="modal fade" id="startTemaproveExercise"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title">Temapr\xF8ve</h4></div><div class="modal-body form-horizontal"><p>Velg temaet du \xF8nsker \xE5 \xF8ve p\xE5</p><div class="form-group"><div class="col-sm-12"><select class="form-control" ng-model="startTemaproveExerciseData.subject"><option>Fart og plassering</option><option>F\xF8rer og eiers Ansvar</option><option>Vikeplikt</option><option>F\xF8rer og andre trafikanter</option><option>Kj\xF8ret\xF8y</option><option>Lover og regler</option><option>Skilt og Oppmerking</option></select></div></div><p>Hvor mange oppgaver \xF8nsker du?</p><div class="form-group"><div class="col-sm-12"><select class="form-control" ng-model="startTemaproveExerciseData.practiceType"><option value="TEMAPROVE_10">10</option><option value="TEMAPROVE_20">20</option><option value="TEMAPROVE_30">30</option></select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Avbryt</span></button> <button class="btn btn-success" ng-click="startTemaproveExercise()" ng-disabled="(startTemaproveExerciseData.subject == null\n                        || startTemaproveExerciseData.subject.length == 0)\n                        || (startTemaproveExerciseData.practiceType == null\n                        || startTemaproveExerciseData.practiceType.length == 0)"><span class="glyphicon glyphicon-book"></span>&nbsp;<span>Start temapr\xF8ve</span></button></div></div></div></div><div class="modal fade" id="startSkiltproveExercise"><div class="modal-dialog"><div class="modal-content"><div class="modal-body form-horizontal"><p>Hvor mange oppgaver \xF8nsker du?</p><div class="btn-group btn-group-lg" data-toggle="buttons"><label class="btn btn-default" ng-click="startSkiltproveExerciseData.numberOfExercises = \'10\'; startSkiltproveExercise()"><input type="radio"> 10</label><label class="btn btn-default" ng-click="startSkiltproveExerciseData.numberOfExercises = \'20\'; startSkiltproveExercise()"><input type="radio"> 20</label><label class="btn btn-default" ng-click="startSkiltproveExerciseData.numberOfExercises = \'30\'; startSkiltproveExercise()"><input type="radio"> 30</label></div></div></div></div></div><div class="modal fade" id="buyAccessModal"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title">Kj\xF8p tilgang n\xE5</h4></div><div class="modal-body"><span class="lead"><h3>Vipps</h3><ol><li>\xC5pne Vipps-appen og trykk p\xE5 "Kj\xF8p og betal"</li><li>S\xF8k opp: best\xE5.no</li><li>Velg best\xE5.no - Ubegrenset tilgang i 40 dager</li><li>Trykk p\xE5 "Legg i handlekurv" og trykk p\xE5 "Handlekurv"</li><li>Husk \xE5 oppgi epost-adressen som du registrerte deg med under "Hjemmelevering"</li><li>Fullf\xF8r betaling</li><li>Gi beskjed til oss p\xE5 <a href="mailto:post@best\xE5.no">post@best\xE5.no</a></li></ol><p>S\xE5 snart vi har mottatt betalingen vil tilgangen til best\xE5.no \xE5pnes igjen.</p><p>Du vil beholde alle tidligere pr\xF8ver.</p><p>Ta kontakt med oss p\xE5 <a href="mailto:post@best\xE5.no">post@best\xE5.no</a> dersom du har noen sp\xF8rsm\xE5l.</p></span><!--table class="lead" style="width: 100%">\n                    <tr>\n                        <td width="30%">\n                            <img style="width: 170px; border:1px solid #021a40;" src="/content/images/vipps.jpg">\n                        </td>\n                        <td width="70%" style="padding-left: 10px">\n                            <h3>Vipps</h3>\n                            <ol>\n                                <li>S\xF8k opp best\xE5.no i Vipps-appen</li>\n                                <li>Velg \xF8nsket produkt</li>\n                                <li>G\xE5 til handlekurven og betal</li>\n                            </ol>\n                            <p>S\xE5 snart vi har mottatt betalingen vil tilgangen til best\xE5.no \xE5pnes igjen.</p>\n                            <p>Du vil beholde alle tidligere pr\xF8ver.</p>\n                            <br><br>\n                            <p>Ta kontakt med oss p\xE5 <a href="mailto:post@best\xE5.no">post@best\xE5.no</a> dersom du har noen\n                                sp\xF8rsm\xE5l.</p>\n                        </td>\n                    </tr>\n                </table--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()">Lukk</button></div></div></div></div>');
$templateCache.put('app/teoriprove/teoriprove-result.html','<div ng-cloak><div class="lead"><span class="label label-success" ng-show="result.passed">GODKJENT</span> <span class="label label-danger" ng-show="!result.passed">IKKE GODKJENT</span> &nbsp;&nbsp;{{result.text}}</div><div><p>Sirkelen under viser de forskjellige temaene og antall feil du hadde i hvert tema. Trykk p\xE5 sirkelen for \xE5 se hvor mange feil du hadde.</p><canvas id="doughnut" class="chart chart-doughnut hidden-xs" chart-data="result.chart.numberOfWrongExercises" chart-labels="result.chart.subjects" chart-options="{ legend: { display: true, labels: { fontSize: 10 } } }"></canvas><canvas id="doughnut-xs" class="chart chart-doughnut visible-xs" chart-labels="result.chart.subjects" chart-data="result.chart.numberOfWrongExercises"></canvas><p>Vi anbefaler \xE5 gjennomf\xF8re en eller flere temapr\xF8ver p\xE5 de temaene hvor du hadde flest feil. Under vises de temaene hvor du hadde mest feil:</p><ul><li ng-repeat="statistic in result.statistics | limitTo: 3" style="margin-top: 2px"><button class="btn btn-xs btn-success" ng-click="showStartTemaproveExerciseModal(statistic.subject)" ng-show="!result.hasInProgressTemaprove" ng-disabled="vm.hasTokenExpired">Start teamapr\xF8ve</button> {{statistic.subject}}: {{statistic.numberOfWrongExercises}} feil</li></ul></div><br><a href="/#!/session/" class="btn btn-default"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> Tilbake til startsiden</a><br><br></div><div class="modal fade" id="startTemaproveExercise"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button><h4 class="modal-title">Temapr\xF8ve</h4></div><div class="modal-body form-horizontal"><p>Velg temaet du \xF8nsker \xE5 \xF8ve p\xE5</p><div class="form-group"><div class="col-sm-12"><select class="form-control" ng-model="startTemaproveExerciseData.subject"><option>Fart og plassering</option><option>F\xF8rer og eiers Ansvar</option><option>Vikeplikt</option><option>F\xF8rer og andre trafikanter</option><option>Kj\xF8ret\xF8y</option><option>Lover og regler</option><option>Skilt og Oppmerking</option></select></div></div><p>Hvor mange oppgaver \xF8nsker du?</p><div class="form-group"><div class="col-sm-12"><select class="form-control" ng-model="startTemaproveExerciseData.practiceType"><option value="TEMAPROVE_10">10</option><option value="TEMAPROVE_20">20</option><option value="TEMAPROVE_30">30</option></select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Avbryt</span></button> <button class="btn btn-success" ng-click="startTemaproveExercise()" ng-disabled="(startTemaproveExerciseData.subject == null\n                        || startTemaproveExerciseData.subject.length == 0)\n                        || (startTemaproveExerciseData.practiceType == null\n                        || startTemaproveExerciseData.practiceType.length == 0)"><span class="glyphicon glyphicon-book"></span>&nbsp;<span>Start temapr\xF8ve</span></button></div></div></div></div>');
$templateCache.put('app/teoriprove/teoriprove.html','<style>.cont {\n  max-height: 300px;\n}\n\n.cont img {\n  max-height:100%;\n  max-width: 100%;\n}</style><div ng-cloak><div class="row" style="margin-bottom: 50px"><div class="col-md-12"><p class="pull-right"><a href="/#!/session/" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></a></p><p style="font-size: 20px" ng-show="exercise.subject.subject">{{exercise.subject.subject}}</p><p style="font-size: 20px" ng-show="!exercise.subject.subject">Skiltpr\xF8ve</p><div><img ng-show="exercise.imageUrl" ng-src="{{exercise.imageUrl}}" class="img-responsive"></div><p style="margin-top: 10px" class="lead">{{exercise.text}}</p></div><div class="pull-right">Oppgave {{exercise.sortOrder}} av {{vm.numberOfExercises}}&nbsp;</div><div class="list-group"><button ng-repeat="option in exercise.options" type="button" class="list-group-item" style="min-height: 60px; background-color: {{option.color}}" ng-click="answer(option)" ng-disabled="showExplanation"><div class="col-xs-2 col-sm-1">{{option.no}}</div><div class="col-xs-10 col-sm-11">{{option.text}}</div></button></div><a class="pull-right" style="margin-top: -18px; color: #d9534f; margin-right: 3px" ng-click="showReportErrorModal(exercise)"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> Rapporter feil</a><div ng-show="showExplanation" class="col-md-12"><p><b>Forklaring</b></p><p>{{exercise.explanation}}</p></div><div style="margin: 5px"><button class="btn btn-default btn-lg col-xs-12" ng-show="showExplanation && !practiceSessionDone" ng-click="next()">Neste oppgave</button> <a class="btn btn-default btn-lg col-xs-12" href="/#!/teoripr\xF8ve/{{exercise.sessionId}}/result" ng-show="showExplanation && practiceSessionDone && practiceType == \'TEORIPROVE\'">Oppgavesett ferdig - G\xE5 til resultat </a><a class="btn btn-default btn-lg col-xs-12" href="/#!/session/" ng-show="showExplanation && practiceSessionDone && practiceType != \'TEORIPROVE\'">Oppgavesett ferdig</a></div><div id="bottomAnchor"></div></div></div><div class="modal fade" id="reportErrorModal"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()"><span class="glyphicon glyphicon-remove"></span></button><h4 class="modal-title">Rapporter feil</h4></div><div class="modal-body"><p>Hvilken type feil \xF8nsker du \xE5 rapportere?</p><select class="form-control" ng-model="errorReport.errorType"><option>Skrivefeil</option><option>Teknisk problem</option><option>Faktafeil</option><option>Annet</option></select><div ng-show="errorReport.errorType == \'Annet\'"><br><textarea class="form-control" ng-model="errorReport.errorMessage" rows="3" placeholder="Forklar kort"></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Avbryt</span></button> <button class="btn btn-success" ng-click="sendErrorReport()"><span class="glyphicon glyphicon-arrow-right"></span>&nbsp;<span>Send inn</span></button></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Aktivering</h1><div class="alert alert-success" ng-show="vm.success"><strong>Brukeren er n\xE5 aktivert.</strong> En e-post er sendt til brukeren med detaljer om innloggingen.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Klarte ikke aktivere denne brukeren.</strong> Ta kontakt med Henning (+47 922 41 014) for hjelp.</div><a href="/#!/" class="btn btn-default pull-left"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> Tilbake til hovedsiden</a></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div ng-cloak><div class="row"><div class="col-md-12 col-xs-12"><h1>Registrer din trafikkskole</h1><div class="alert alert-success" ng-show="vm.success"><strong>Registrering mottatt!</strong> Du vil om kort tid bli kontaktet for bekreftelse.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Registrering feilet!</strong> Vennligst pr\xF8v igjen senere.</div><div class="alert alert-danger" ng-show="vm.errorUserExists"><strong>Brukernavnet finnes allerede!</strong> Vennligst velg et annet brukernavn.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists"><strong>E-post er allerede i bruk!</strong> Vennligst velg en annen.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">Passordet og bekreft passord er forskjellig!</div></div><div class="col-sm-12"><img style="width: 100%" class="shadow" src="content/images/register-image.jpg"></div><div class="col-md-12 col-xs-12" style="margin-top: 20px"><div class="col-sm-12"><div class="alert alert-info" role="alert"><span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span> <span>Merk: det er kun ansatte i trafikkskoler som skal registrere seg her. Elever vil f\xE5 tilsendt en link p\xE5 e-post. Er du elev og ikke f\xE5tt en link? Ta kontakt med trafikkskolen din.</span></div></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="col-md-6"><div class="form-group"><label class="control-label" for="company">Trafikkskole*</label><table style="width: 100%"><tr><td width="70%"><input type="text" class="form-control" id="company" name="companyName" placeholder="Trafikkskole" ng-model="vm.registerAccount.company" required></td><td style="padding-left: 3px"><input type="text" class="form-control" id="orgNo" name="orgNo" placeholder="Org.no" ng-model="vm.registerAccount.orgNo" required></td></tr></table></div><div class="form-group"><label class="control-label" for="firstname">Kontaktperson*</label><input type="text" class="form-control" id="firstname" name="firstname" placeholder="Navn" ng-model="vm.registerAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="(form.firstname.$dirty && form.firstname.$invalid)"><p class="help-block" ng-show="form.firstname.$error.required">Du m\xE5 skrive inn et navn</p></div></div><div class="form-group"><label class="control-label" for="address">Adresse*</label><input type="text" class="form-control" id="address" name="address" placeholder="Adresse" ng-model="vm.registerAccount.address" required><table style="width: 100%"><tr><td width="30%"><input style="margin-top: 3px" type="text" class="form-control" id="zip" name="zip" placeholder="Postnummer" ng-model="vm.registerAccount.zip" required></td><td style="padding-left: 3px"><input style="margin-top: 3px" type="text" class="form-control" id="postLocation" name="postLocation" placeholder="Poststed" ng-model="vm.registerAccount.postLocation" required></td></tr></table><div ng-show="form.address.$dirty && form.address.$invalid"><p class="help-block" ng-show="form.address.$error.required">Du m\xE5 skrive inn en adresse</p></div><div ng-show="form.postno.$dirty && form.postno.$invalid"><p class="help-block" ng-show="form.postno.$error.required">Du m\xE5 skrive inn et postnummer</p></div><div ng-show="form.postlocation.$dirty && form.postlocation.$invalid"><p class="help-block" ng-show="form.postlocation.$error.required">Du m\xE5 skrive inn poststed</p></div></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="phone">Telefon</label><input type="text" class="form-control" id="phone" name="phone" placeholder="Telefon" ng-model="vm.registerAccount.phone"></div><div class="form-group"><label class="control-label" for="email">E-post (brukernavn)*</label><input type="email" class="form-control" id="email" name="email" placeholder="Din e-post" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Vennligst skriv inn e-post.</p><p class="help-block" ng-show="form.email.$error.email">E-post adressen er ikke gyldig.</p><p class="help-block" ng-show="form.email.$error.minlength">E-post adressen m\xE5 v\xE6re mer enn 5 bokstaver/tegn.</p><p class="help-block" ng-show="form.email.$error.maxlength">E-post adressen kan ikke v\xE6re mer enn 100 bokstaver/tegn.</p></div></div><div class="form-group"><label class="control-label" for="password">Passord*</label><input type="password" class="form-control" id="password" name="password" placeholder="Nytt passord" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Vennligst skriv inn et passord.</p><p class="help-block" ng-show="form.password.$error.minlength">Passordet m\xE5 v\xE6re p\xE5 minst 4 bokstaver/tall.</p><p class="help-block" ng-show="form.password.$error.maxlength">Passordet kan ikke v\xE6re mer enn 50 bokstaver/tall.</p></div><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Bekreft nytt passord" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" style="margin-top: 3px" required><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Vennligst skriv inn et passord.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Passordet m\xE5 v\xE6re minst 4 bokstaver/tall.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Passordet kan ikke v\xE6re mer enn 50 bokstaver/tall.</p></div></div></div><div class="col-md-12"><em>Registrering av trafikkskole er gratis. Husk \xE5 registrer deg med trafikkskolens epostadresse og telefon tilknyttet skolen, du vil bli kontaktet p\xE5 mail eller telefon for bekreftelse. Du f\xE5r mer info og fordeler n\xE5r du er godkjent. Har du sp\xF8rsm\xE5l, ta kontakt p\xE5: <a href="mailto:post@best\xE5.no">post@best\xE5.no</a> eller tlf <b>90853324</b>.</em></div><div class="col-md-12" style="margin-top: 10px"><a href="/#!/" class="btn btn-default pull-left"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> Tilbake til hovedsiden </a><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary pull-right">Registrer</button></div></form><a href="/#!/" class="btn btn-default pull-left" ng-show="vm.success"><span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span> Tilbake til hovedsiden</a><p>&nbsp;</p></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName">Navn</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email">E-post</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Lagre</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2>Audits</h2><div class="row"><div class="col-md-5"><h4>Filter by date</h4><p class="input-group"><span class="input-group-addon">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2>Configuration</h2><span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th><th class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/error-report/error-report.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1>Feil-rapporter</h1><table class="table table-condensed table-hover"><th>Oppgave ID</th><th>Feiltype</th><th>URL</th><th>Beskrivelse</th><th></th><tr ng-repeat="error in vm.errorReport | orderBy: \'exerciseId\'"><td>{{error.exerciseId}}</td><td>{{error.errorType}}</td><td><a href="/#!/admin/exercises/{{error.exerciseId}}" target="_blank">\xC5pne oppgave i nytt vindu</a></td><td>{{error.errorMessage}}</td><td align="right"><a style="color: #d9534f; cursor: pointer" ng-click="showConfirmDialog(error)"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></a></td></tr></table></div></div></div><div class="modal fade" id="confirmDelete"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="deleteErrorReport()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title">Bekreft sletting</h4></div><div class="modal-body"><p>Er du sikker p\xE5 at du vil slette denne raden?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Avbryt</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-check"></span>&nbsp;<span>Ja, slett</span></button></div></form></div></div></div>');
$templateCache.put('app/admin/exercise/exercise-detail.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1>Endre oppgave</h1><form class="form-horizontal"><div class="form-group"><label for="inputLicenseClass" class="col-sm-1 control-label">Klasse</label><div class="col-sm-11" id="inputLicenseClass"><button type="button" class="btn btn-default btn-sm dropdown-toggle form-control" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span style="font-size: 14px; color: #aaa" class="pull-left" ng-show="!vm.exercise.licenseClass">Velg klasse</span> <span style="font-size: 14px; color: #555" class="pull-left" ng-show="vm.exercise.licenseClass">{{vm.exercise.licenseClass.name}}</span> <span class="pull-right"><span class="caret"></span></span></button><ul class="dropdown-menu dropdown-menu-right" style="min-width: 150px"><li ng-repeat="licenseClass in vm.licenseClasses"><a ng-click="vm.exercise.licenseClass = licenseClass;" style="cursor: pointer">{{licenseClass.name}}</a></li></ul></div></div><div class="form-group"><label for="inputType" class="col-sm-1 control-label">Type</label><div class="col-sm-11" id="inputType"><button type="button" class="btn btn-default btn-sm dropdown-toggle form-control" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span style="font-size: 14px; color: #aaa" class="pull-left" ng-show="!vm.exercise.type">Velg type</span> <span style="font-size: 14px; color: #555" class="pull-left" ng-show="vm.exercise.type">{{vm.exercise.type.name}}</span> <span class="pull-right"><span class="caret"></span></span></button><ul class="dropdown-menu dropdown-menu-right" style="min-width: 150px"><li ng-repeat="type in vm.types"><a ng-click="vm.exercise.type = type;" style="cursor: pointer">{{type.name}}</a></li></ul></div></div><div class="form-group"><label for="inputSubject" class="col-sm-1 control-label">Tema</label><div class="col-sm-11" id="inputSubject"><button type="button" class="btn btn-default btn-sm dropdown-toggle form-control" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ng-disabled="vm.exercise.type.value == \'ROAD_SIGN\';"><span style="font-size: 14px; color: #aaa" class="pull-left" ng-show="!vm.exercise.subject2020">Velg tema</span> <span style="font-size: 14px; color: #555" class="pull-left" ng-show="vm.exercise.subject2020">{{vm.exercise.subject2020.subject}}</span> <span class="pull-right"><span class="caret"></span></span></button><ul class="dropdown-menu dropdown-menu-right" style="min-width: 150px"><li ng-repeat="subject in vm.subjects | filter: {versionYear: 2020}"><a ng-click="vm.exercise.subject2020 = subject;" style="cursor: pointer">{{subject.subject}}</a></li></ul></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-1 control-label">Tekst</label><div class="col-sm-11"><input type="text" ng-model="vm.exercise.text" class="form-control" id="inputPassword3" placeholder="Oppgavetekst"></div></div><div class="form-group"><label for="inputExplanation" class="col-sm-1 control-label">Forklaring</label><div class="col-sm-11"><textarea type="text" ng-model="vm.exercise.explanation" class="form-control" id="inputExplanation" placeholder="Utfyllende forklaring" rows="5"></textarea></div></div><div class="form-group"><label for="file" class="col-sm-1 control-label">Bilde</label><div class="col-sm-3"><input type="file" class="form-control" id="file" name="file"></div><div class="col-sm-8"><a class="btn btn-default" ng-click="vm.removeImage()"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span> Slett bilde</a></div></div><div ng-show="vm.previewImage == true" class="col-sm-offset-1"><h5>Forh\xE5ndsvisning av nytt bilde</h5><img id="image" src="#" alt="exercise image" height="120px"></div><div ng-show="vm.exercise.imageUrl.length > 0" class="col-sm-offset-1"><img ng-src="{{vm.exercise.imageUrl}}" height="120px"></div><div class="col-sm-offset-1 col-sm-11"><h4 class="pull-left">Svar-alternativer</h4><a ng-click="vm.addOption()" style="margin-top: 5px" class="btn btn-primary btn-sm pull-right"><i class="glyphicon glyphicon-plus"></i> Legg til nytt alternativ</a><table class="table table-striped"><th>Tekst</th><th>Riktig/galt</th><th></th><tr ng-repeat="option in vm.exercise.options"><td><input type="text" class="form-control" ng-model="option.text"></td><td style="width: 150px"><select ng-model="option.correct" class="form-control" ng-options="o.v as o.n for o in [{ n: \'Galt\', v: false }, { n: \'Riktig\', v: true }]"></select></td><td style="width: 30px; font-size: 30px; padding: 3px"><a ng-click="removeOption(option)"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span></a></td></tr></table></div><div class="form-group"><div class="col-sm-offset-1 col-sm-11"><a href="/#!/admin/exercises" class="btn btn-default"><i class="glyphicon glyphicon-arrow-left"></i> Liste </a><button ng-click="vm.save()" class="btn btn-default"><i class="glyphicon glyphicon-ok"></i> Lagre oppgave</button><div class="pull-right"><button ng-click="vm.prev()" ng-disabled="vm.currentId == 1" class="btn btn-default"><i class="glyphicon glyphicon-arrow-left"></i> Forrige oppgave</button> <button ng-click="vm.next()" class="btn btn-default">Neste oppgave <i class="glyphicon glyphicon-arrow-right"></i></button></div></div></div></form></div></div></div>');
$templateCache.put('app/admin/exercise/exercise.html','<div ng-cloak><div class="row"><div class="col-md-12"><div class="btn-group pull-right" style="margin-top: 10px"><a type="button" class="btn btn-default btn-md" href="/#!/admin/exercises/new"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> Legg til ny oppgave</a></div><p style="font-size: 35px">Oppgaver</p><!-- Search field. --><div class="input-group input-group-lg"><div class="input-group-addon"><i class="glyphicon glyphicon-search"></i></div><input type="text" class="form-control" placeholder="S\xF8k i oppgaver" ng-model="searchTable"></div><br><table class="table table-striped table-hover"><th><a ng-click="sortType = \'sortOrder\'; sortReverse = !sortReverse"># <span ng-show="sortType == \'sortOrder\' && !sortReverse" class="small glyphicon glyphicon-triangle-bottom"></span> <span ng-show="sortType == \'sortOrder\' && sortReverse" class="small glyphicon glyphicon-triangle-top"></span></a></th><th><a ng-click="sortType = \'licenseClassName\'; sortReverse = !sortReverse">Klasse <span ng-show="sortType == \'licenseClassName\' && !sortReverse" class="small glyphicon glyphicon-triangle-bottom"></span> <span ng-show="sortType == \'licenseClassName\' && sortReverse" class="small glyphicon glyphicon-triangle-top"></span></a></th><th><a ng-click="sortType = \'name\'; sortReverse = !sortReverse">Type <span ng-show="sortType == \'name\' && !sortReverse" class="small glyphicon glyphicon-triangle-bottom"></span> <span ng-show="sortType == \'name\' && sortReverse" class="small glyphicon glyphicon-triangle-top"></span></a></th><th><a ng-click="sortType = \'subject\'; sortReverse = !sortReverse">Tema <span ng-show="sortType == \'subject\' && !sortReverse" class="small glyphicon glyphicon-triangle-bottom"></span> <span ng-show="sortType == \'subject\' && sortReverse" class="small glyphicon glyphicon-triangle-top"></span></a></th><th><a ng-click="sortType = \'text\'; sortReverse = !sortReverse">Oppgavetekst <span ng-show="sortType == \'text\' && !sortReverse" class="small glyphicon glyphicon-triangle-bottom"></span> <span ng-show="sortType == \'text\' && sortReverse" class="small glyphicon glyphicon-triangle-top"></span></a></th><!--th>Bilde</th--><th></th><tr ng-repeat="exercise in exercises | orderBy:sortType:sortReverse | filter:searchTable"><td style="width: 50px">{{exercise.sortOrder}}</td><td style="width: 130px">{{exercise.licenseClass.name}}</td><td>{{exercise.type.name}}</td><td>{{exercise.subject.subject}}</td><td>{{exercise.text}}</td><!--td>\n                        <span ng-show="exercise.imageUrl.length > 0" class="glyphicon glyphicon-ok" aria-hidden="true"></span>\n                        <span ng-hide="exercise.imageUrl.length > 0" class="glyphicon glyphicon-remove" aria-hidden="true"></span>\n                    </td--><td style="width: 100px; font-size: 24px; padding: 3px"><a href="#!/admin/exercises/{{exercise.id}}"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span> </a><a style="padding-left: 10px" ng-click="showConfirmDialog(exercise)"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span></a></td></tr></table></div></div></div><div class="modal fade" id="confirmDelete"><div class="modal-dialog"><div class="modal-content"><form name="deleteForm" ng-submit="deleteExercise()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="clear()">&times;</button><h4 class="modal-title">Bekreft sletting</h4></div><div class="modal-body"><p>Er du sikker p\xE5 at du vil slette denne oppgaven?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Avbryt</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-success"><span class="glyphicon glyphicon-check"></span>&nbsp;<span>Ja, slett denne oppgaven</span></button></div></form></div></div></div>');
$templateCache.put('app/admin/health/health.html','<div><h2>Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{ health.status }}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span> {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4>Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2>Logs</h2><p>There are {{ vm.loggers.length }} loggers.</p><span>Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2>Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><h3>JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b>Memory</b><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Garbage collections</b><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/token/token.html','<div ng-cloak><div class="row"><div class="col-md-12"><h1>N\xF8kler</h1><table class="table table-condensed table-hover"><th>Status</th><th>Registert</th><th>Skole</th><th>Student</th><th>E-post</th><th>Telefon</th><th>Opprettet</th><th>Sendt til e-post</th><th>\xC5pne</th><tr ng-repeat="token in vm.allTokens"><td>{{token.status}}</td><td>{{token.registeredTime}}</td><td>{{token.school}}</td><td>{{token.student}}</td><td>{{token.email}}</td><td>{{token.phone}}</td><td>{{token.createdTime}}</td><td>{{token.sentToEmail}}</td><td><a href="/#!/session/{{token.token}}" title="\xC5pne" target="_blank"><span class="glyphicon glyphicon-new-window" aria-hidden="true"></span></a></td></tr></table></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span>User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span>Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span>First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span>Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span>Email</span></dt><dd>{{vm.user.email}}</dd><dt><span>Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span>Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span>Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span>Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span>Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span>Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label>ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label>Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span>Activated</span></label></div><div class="form-group"><label>Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2>Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span>Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th><span>Profiles</span></th><th jh-sort-by="createdDate"><span>Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span>Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" style="cursor: pointer">Activated</span></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Innlogging</h4></div><div class="modal-body"><div class="row"><div class="col-md-8 col-md-offset-2 text-center"><img src="content/images/logo_besta.png" alt="logo"></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError"><strong>Klarte ikke logge inn</strong> Sjekk at du har tastet riktig brukernavn og passord.</div></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-info" role="alert"><span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span> <span>Denne innloggingen er kun for trafikkskoler. Er du elev og vil ha tilgang? Ta kontakt med trafikkskolen din eller g\xE5 til <a href="/#!/privatpersoner" ng-click="vm.closeLoginModal()">privatpersoner</a> for \xE5 kj\xF8pe tilgang.</span></div><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username">Brukernavn</label><input type="text" class="form-control" id="username" placeholder="Brukernavn" ng-model="vm.username"></div><div class="form-group"><label for="password">Passord</label><input type="password" class="form-control" id="password" placeholder="Passord" ng-model="vm.password"></div><div class="form-group" style="margin-top: -10px"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span>Husk meg</span></label><div class="pull-right"><a class="alert-link" href="" ng-click="vm.requestResetPassword()">Glemt passord?</a></div></div><button type="submit" class="btn btn-primary pull-left">Logg inn</button><div class="pull-right"><a class="btn btn-default" href="" ng-click="vm.register()">G\xE5 til registrering</a></div></form><p><br></p></div></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div class="alert alert-danger">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-inverse" role="navigation"><div class="container-fluid"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo2.png" alt="logo"> <span>best\xE5</span> <span class="navbar-version">- n\xE5r du vil best\xE5 teoripr\xF8ven</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active" has-any-authority="ROLE_USER, ROLE_ADMIN"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm">Hjem</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="error-report" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-warning-sign"></span> <span class="hidden-sm">Feil-rapporter</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="tokens" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-paperclip"></span> <span class="hidden-sm">N\xF8kler</span></a></li><li ng-class="{active: vm.$state.includes(\'exercises\')\n                        || vm.$state.includes(\'exercises.detail\') || vm.$state.includes(\'exercises.new\')}" has-authority="ROLE_ADMIN"><a ui-sref="exercises" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-blackboard"></span> <span class="hidden-sm">Oppgaver</span></a></li><!-- Only show the account dropdown when user is authenticated. --><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer" ng-switch-when="true" ng-show="!vm.$state.includes(\'session\')"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm">Konto </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span>Innstillinger</span></a></li><li ui-sref-active="active"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span>Passord</span></a></li><li ui-sref-active="active"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Logg ut</span></a></li><!--li ui-sref-active="active" ng-switch-when="false">\n                            <a href="" ng-click="vm.login()" id="login">\n                                <span class="glyphicon glyphicon-log-in"></span>&nbsp;\n                                <span>Sign in</span>\n                            </a>\n                        </li--><!--li ui-sref-active="active" ng-switch-when="false">\n                            <a ui-sref="register" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-plus-sign"></span>&nbsp;\n                                <span>Register</span>\n                            </a>\n                        </li--></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span>Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span>Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span>Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span>Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span>Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span>API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><li ng-hide="vm.inProduction"><a href="/h2-console" target="_tab" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-hdd"></span>&nbsp; <span>Database</span></a></li></ul></li><li ui-sref-active="active" ng-switch-when="false" ng-show="!vm.$state.includes(\'session\')"><a ng-click="vm.login()"><span class="glyphicon glyphicon-lock"></span> Innlogging</a></li></ul></div></div></nav>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Nullstill passord</h1><div class="alert alert-danger" ng-show="vm.keyMissing"><strong>Reset token mangler!</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p>Skriv inn nytt passord</p></div><div class="alert alert-danger" ng-show="vm.error"><p>Passordet kunne ikke nullstilles. Merk: nullstill av passord er bare gyldig i 24 timer.</p></div><div class="alert alert-success" ng-show="vm.success"><p><strong>Passordet ditt er endret.</strong> Vennligst <a class="alert-link" href="" ng-click="vm.login()">logg inn</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch">Passordet og bekreft passord er forskjellig!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password">Nytt passord</label><input type="password" class="form-control" id="password" name="password" placeholder="Nytt passord" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Vennligst skriv inn et passord.</p><p class="help-block" ng-show="form.password.$error.minlength">Passordet m\xE5 v\xE6re minst 4 bokstaver/tall.</p><p class="help-block" ng-show="form.password.$error.maxlength">Passordet kan ikke v\xE6re mer enn 50 bokstaver/tall.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">Bekreft passord</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Bekreft passord" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Vennligst skriv inn et passord.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Passordet m\xE5 v\xE6re minst 4 bokstaver/tall.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Passordet kan ikke v\xE6re mer enn 50 bokstaver/tall.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Nullstill passord</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Nullstill passord</h1><div class="alert alert-danger" ng-show="vm.errorEmailNotExists"><strong>En feil oppstod!</strong> Vennlist pr\xF8v igjen litt senere.</div><div class="alert alert-warning" ng-hide="vm.success"><p>Skriv inn e-post adressen du brukte da du registrerte deg.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p>Instrukser for \xE5 nullstille passordet ditt er sendt til din e-post.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email">Epost</label><input type="email" class="form-control" id="email" name="email" placeholder="Din epost" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Vennligst skriv inn e-post.</p><p class="help-block" ng-show="form.email.$error.email">E-post adressen er ikke gyldig.</p><p class="help-block" ng-show="form.email.$error.minlength">E-post adressen m\xE5 v\xE6re mer enn 5 bokstaver/tegn.</p><p class="help-block" ng-show="form.email.$error.maxlength">YE-post adressen kan ikke v\xE6re mer enn 100 bokstaver/tegn.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Nullstill passord</button></form></div></div></div>');}]);})();